<!-- 货运管理-->
<template>
    <div class="page-box" ref="pageBox">
        <!-- style="position:fixed; top:0px;" -->
        <ctrl-box ref="ctrlBoxRef" class="ctrl-box" :data="{}" v-reheight="ctrlBoxHeightChanged">
            <template>
                <view-selector @change="changeViews" :type="1" ref="viewSelectofRef"></view-selector>
                
                <div class="xgroup" v-if="viewSetting && viewSetting.btns && viewSetting.btns.length>0">
                   <template v-for="(item, idx) in dicts.stockBtns">
                       <template v-if="viewSetting.btns.indexOf(item.name)>-1 && hasPermissions(item.permission,'or')">
                            <el-dropdown v-if="item.children && item.children.length>0" :key="'dropdown-' + idx"
                                @command="(cmd)=> callMethod(item.action, cmd)" 
                            >
                                <el-link :underline="false">
                                    <div class="wrap" >
                                        <!-- <i :class="item.icon"></i> -->
                                        <icon-svg :icon-class="item.icon" font-size="27px;"/>
                                        <span class="txt" :style="item.labelStyle">{{msg(item.name)}}</span>      
                                    </div>
                                </el-link>
                                <el-dropdown-menu slot="dropdown">
                                    <template v-for="(sub, idx1) in item.children" >
                                        <el-dropdown-item :key="idx1" v-if="viewSetting.btns.indexOf(sub.name)>-1 && hasPermissions(sub.permission,'or')" 
                                            :command="sub.command" >{{msg(sub.name)}}</el-dropdown-item>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <el-link v-else :key="'link-' + idx"
                                    :underline="false" @click="callMethod(item.action, item.para)">
                                <div class="wrap" >
                                    <!-- <i :style="item.iconStyle" :class="item.icon" ></i> -->
                                    <icon-svg :icon-class="item.icon" font-size="27px;"/>
                                    <span class="txt"  :style="item.labelStyle">{{msg(item.name)}}</span>      
                                </div>
                            </el-link>
                       </template>
                    </template>
                </div> 
            </template>
        </ctrl-box>
        <div class="empty-fixed-box" v-bind:style="{height:emptyFixedBoxHeight}"></div>
        <!--查询区域-->
        <transition name="el-zoom-in-top">
            <query-box :query="query" v-show="showQuery" labelWidth="80px">
                <template v-slot:default="scope">
                    <template v-for="q in scope.query.queries" >
                        <el-form-item :key="q.id" v-if="q.disabled == 0"
                            :label="q.nlabel? q.nlabel : q.label" >
                                <div v-if="q.colName == 'allcode'" style="display:flex;">
                                    <el-input type="textarea" v-model="q.dvalue" :rows="2" 
                                        :placeholder="q.placeholder"  clearable
                                    >
                                    </el-input>
                                    <el-select v-model="q.optType" style="min-width: 80px; width:80px;">
                                        <el-option  label="订单号" :value="1"></el-option>
                                        <el-option  label="查询码" :value="2"></el-option>
                                        <el-option  label="面单码" :value="3"></el-option>
                                        <el-option  label="组合查" :value="4"></el-option>
                                    </el-select>
                                </div>
                                <div v-else-if="q.colName == 'alllikecode'" style="display:flex;">
                                    <el-input type="input" v-model="q.dvalue" :rows="2" 
                                        placeholder="至少4码（订查面混合 快组左包含）"  clearable
                                    >
                                    </el-input>
                                    <el-select v-model="q.optType" style="min-width: 80px; width:80px;">
                                        <el-option  label="订单号" :value="1"></el-option>
                                        <el-option  label="查询码" :value="2"></el-option>
                                        <el-option  label="面单码" :value="3"></el-option>
                                        <el-option  label="快递号" :value="5"></el-option>
                                        <el-option  label="组合查" :value="4"></el-option>
                                    </el-select>
                                </div>
                                <span v-else>
                                    <span v-if="q.type == 0">
                                        <el-input v-if="q.op != 6" v-model="q.dvalue" :placeholder="q.placeholder"  clearable>
                                        </el-input>
                                        <el-input v-else type="textarea" v-model="q.dvalue" :rows="2" 
                                        :placeholder="q.placeholder"  clearable></el-input>
                                    </span>
                                    <el-input v-else-if="q.type == 1" v-model="q.dvalue" :placeholder="q.placeholder"  clearable></el-input>
                                    <span v-else-if="q.type == 2">
                                        <el-select v-if="q.op === 0" v-model="q.dvalue" size="mini" clearable :placeholder="q.placeholder">
                                            <span v-if="q.filterOptionKey=='expCompany'">
                                                <el-option v-for="d in expCompanys" 
                                                    :key="d.value" :label="d.label" :value="d.value">
                                                </el-option>
                                            </span>
                                            <span v-else>
                                                <el-option v-for="d in getDicts(q.filterOptionKey)" 
                                                    :key="d.value" :label="d.label" :value="d.value">
                                                </el-option>
                                            </span>
                                        </el-select>
                                        <el-select v-else v-model="q.dvalues" multiple size="mini" clearable :placeholder="q.placeholder">
                                            <span v-if="q.filterOptionKey=='expCompany'">
                                                    <el-option v-for="d in expCompanys" 
                                                    :key="d.value" :label="d.label" :value="d.value">
                                                </el-option>
                                            </span>
                                            <span v-else>
                                                <el-option v-for="d in getDicts(q.filterOptionKey)" 
                                                    :key="d.value" :label="d.label" :value="d.value">
                                                </el-option>
                                            </span>
                                        </el-select> 

                                    </span>
                                    <el-date-picker v-if="q.type == 3" clearable
                                        v-model="q.dvalues" value-format="yyyy-MM-dd"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </el-date-picker>
                                    <el-date-picker v-if="q.type == 4" clearable 
                                        v-model="q.dvalues" value-format="yyyy-MM-dd HH:mm:ss"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                    </el-date-picker>
                                </span>
                        </el-form-item>
                    </template>
                    <el-row>
                        <el-button type="primary" icon="el-icon-search" @click="list" size="mini">{{msg('搜索')}}</el-button>
                        <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                    </el-row>
                </template>
            </query-box>
        </transition>
        <div class="table-wrap">
            <vxe-grid ref="dataTable" :height="docHeight"  
                :export-config="exportConfig" stripe
                resizable border="full"
                highlight-current-row highlight-hover-column highlight-current-column
                show-overflow show-header-overflow 
                :data="datas"
                size="mini"
                :columns="columns"
                @cell-click="clickRow"
                :scroll-x="{gt: 20}"
                :scroll-y="{gt: 20}"
                :checkbox-config="{highlight:true, trigger: 'cell'}"
            ></vxe-grid>

            <pagenator @page-change="handlerPageChange" :query="query" >
            </pagenator>
        </div>

        <drawer :title="dgTitle" :width="isMinScreen?'100%':'30%'"
            :content-width="'100%'"
            :visible.sync="dgVisible">
                <edit :stock="curr" :view-setting="viewSetting"  :detail-editable="detailEditable" :exp-code-edit="expCodeEdit" :ant-order-edit="antOrderEdit"
                    @close-dg="closeEditDialog" ref="editDg"/>
        </drawer>

        <drawer :title="msg('批量更新指定内容')" :width="isMinScreen?'100%':'50%'"
            :content-width="'100%'"
            :visible.sync="batchUpdateVisible">
                <batch-update :datas="batchDatas" @close-dg="closeBatchUpdateDialog" ref="batchUpdateRef"/>
        </drawer>

        <drawer :title="msg('自定义批量更新')" :width="isMinScreen?'100%':'50%'"
            :content-width="'100%'"
            :visible.sync="batchUpdateNewVisible">
                <batch-update-new :datas="batchDatas" @close-dg="closeBatchUpdateNewDialog" ref="batchUpdateNewRef"/>
        </drawer>

        <el-dialog :title="msg('查看面单')" :close-on-click-modal="false" 
            :visible.sync="imgVisiable" width="800px"
            :fullscreen="isMinScreen">
                <page-view :imgId="pageId" @close-dg="imgVisiable = false" />
        </el-dialog>

        <!--物流查詢-->
        <trace ref="traceRef"></trace>

        <el-popover
                ref="colsPopover"
                width="200"
                placement="bottom"
                v-model="colsPopVisible"
                trigger="click">
            <el-scrollbar style="height:300px;">
                <div v-for="(c, idx) in genColumns" :key="idx">
                    <el-checkbox v-if="idx>1" v-model="c.visible"
                            @change="(val)=>refreshCols(val, c)"
                        >{{c.title}}</el-checkbox>
                </div>
            </el-scrollbar>
        </el-popover>
        
        <!--下面是弹窗 dialog-->
        <!--批量上传面单-->
        <stock-page-import ref="stockPageImport"/>
        <!--导入PDF资料-->
        <stock-page-only-import ref="stockPageOnlyImport"/>
        <!--分包加单-->
        <stock-add-pkg ref="addAddPkgRef" v-on:finish="closeAddPkgDialog"/>
        <!--重量分摊-->
        <stock-weight-share ref="weightShareRef" v-on:close-dg="closeWeightShareDialog"/>
        <!--转运-->
        <zhuan-pkg ref="zhuanyunRef"/>
        <!--货运代打包-->
        <stock-pkg-type ref="pkgTypeDg" />
        <!--跨仓合并包-->
        <stock-start-pkg-type ref="startPkgTypeDg" />
        <!--自定义打印-->
        <print-custom-dialog ref="PrintCustomDialogRef" />
        <!-- 快递分拣 -->
        <express-sorting ref="expressSortingRef" />
        <!-- 库存分拣 -->
        <stock-sorting ref="expStockRef"  />
        <!-- 库存状态记录 -->
        <inventory-trace ref="inventoryTraceRef"/>

        <!-- 订单拆分 -->
        <order-split-dialog ref="orderSplitDialogRef"/>

        <el-dialog :title="msg('弃件处理')" :visible.sync="qijianVisible" :fullscreen="isMinScreen"  @opened="openedQijian"
            :close-on-click-modal="false"
                width="900px">
            <qijian-handle ref="qijianRef" v-on:close-dg="closeQijianDialog"/>
        </el-dialog>

        <!--打印'-->
        <stock-print :print-ctrls="printCtrls" ref="printDg" @print-finish = "printFinish"/>

        <!-- 打印出货码 -->
        <stock-print2 ref="printDg2" />
        <!-- 打印查询码 -->
        <print-tag2 ref="printTagDg2"></print-tag2>
        <!-- 打印拣货单&出货码 -->
        <stock-print3 ref="printDg3"></stock-print3>
        <!--打印拣货单&自定义快递单-->
        <stock-print4 :print-ctrls="printCtrls" ref="printDg4" />
        <!-- 打印拣货单&查询码 -->
        <stock-print5 ref="printDg5" />
        <!-- 打印自定义快递单 -->
        <stock-print6 :print-ctrls="printCtrls" ref="printDg6" />
        <!-- 打印中通快递单 -->
        <stock-print7 ref="printDg7"/>
         <!-- 打印拣货单&中通快递单 -->
        <stock-print8 ref="printDg8" />

        <!--  -->
        <export-by-keyword ref="ExportByKeywordRef"></export-by-keyword>
        <!--快递同步-->
        <sync-express ref="SyncExpressDialogRef" @finish="doSyncExpress"/>

        <sync-order ref="SyncOrderRef" :is-min-screen="isMinScreen"/>

        <el-dialog :title="msg('包号录入')" :visible.sync="pkgCodeVisible" :fullscreen="isMinScreen" @opened="openedPkgCode"
            :close-on-click-modal="false" 
                width="800px">
            <pkg-code ref="pkgCodeDg"  v-on:close-dg="pkgCodeClose"/>
        </el-dialog>

        <el-dialog :title="msg('扫码打包')" :visible.sync="packageVisible" :fullscreen="isMinScreen" @opened="openedPackage"
            :close-on-click-modal="false" 
                width="600px">
            <auto-pkg-code ref="packageDg"  v-on:close-dg="() => packageVisible = false" />
        </el-dialog>

        <el-dialog :title="msg('转寄找货单')" :visible.sync="printFindVisible" :fullscreen="isMinScreen"  @opened="openedFindPrint"
            :close-on-click-modal="false" 
                width="800px">
            <stock-print-find :print-ctrls="printCtrls" ref="printFindDg" v-on:close-dg="() => printFindVisible = false"/>
        </el-dialog>

        <el-dialog :title="msg('转运找货单')" :visible.sync="printPkgCodeVisible" :fullscreen="isMinScreen" @opened="openedPrintPkgCode"
            :close-on-click-modal="false" 
                width="800px">
            <stock-print-pkg-code ref="printPkgCodeDg"  v-on:close-dg="() => printPkgCodeVisible = false"/>
        </el-dialog>

        <el-dialog :title="msg('待贴单包裹')" :visible.sync="printPkgPageVisible" :fullscreen="isMinScreen" @opened="openedPrintPkgPage"
            :close-on-click-modal="false" 
                width="600px">
            <stock-print-pkg-page ref="printPkgPageDg" v-on:close-dg="() => printPkgPageVisible = false"/>
        </el-dialog>

        <el-dialog :title="msg('提货表')" :visible.sync="exportVisiable" :fullscreen="isMinScreen"  @opened="openExportDg"
            :close-on-click-modal="false" 
                width="400px" >
            <export-tihuo ref="exportDg" :tihuoPkgCodes="tihuoPkgCodes" @close-dg="closeTihuoDg"/>
        </el-dialog> 

        <el-dialog :title="msg('通知收件')" :visible.sync="receiveVisible" :fullscreen="isMinScreen" @opened="openedReceive"
            :close-on-click-modal="false" 
                width="400px">
            <stock-receive :ids="receiveIds" ref="receiveDg" @close-dg="closeReceiveDg" />
        </el-dialog>

        <el-dialog :title="msg('录查询码')" :visible.sync="expCodeVisible" :fullscreen="isMinScreen" @opened="openedExpCode"
            :close-on-click-modal="false" 
                width="600px">
            <exp-code-input ref="expCodeRef" @close-dg="expCodeDg" />
        </el-dialog>

        <el-dialog :title="msg('录退件码')" :visible.sync="returnCodeVisible" :fullscreen="isMinScreen" @opened="openedReturnCode"
            :close-on-click-modal="false" 
                width="600px">
            <return-code-input ref="returnCodeRef" @close-dg="returnCodeDg" />
        </el-dialog>

        <el-dialog :title="msg('扫码找货')" :visible.sync="actualCodeVisible" :fullscreen="isMinScreen" @opened="openedActualCode"
            :close-on-click-modal="false" 
                width="600px">
            <exp-code-check :ordercode="scanCode" ref="actualCodeRef" @close-dg="actualCodeDg" />
        </el-dialog>

        <el-dialog :title="msg('货物交接')" :visible.sync="jiaojieVisible" :fullscreen="isMinScreen" @opened="openedJiaojie"
            :close-on-click-modal="false" 
                width="600px">
            <handover ref="jiaojieRef" @close-dg="jiaojieDg" />
        </el-dialog>

        <el-dialog :title="msg('代打包登记')" :visible.sync="packVisible" :fullscreen="isMinScreen" @opened="openedPack"
            :close-on-click-modal="false" 
                width="600px">
            <pack-input ref="packRef" @close-dg="packDg" />
        </el-dialog>

        <!-- 快递货物 -->
        <inner-exp-code-dg ref="kuaidiRef" />

        <el-dialog :title="msg('集运收费报单')" :visible.sync="zhuanyunChargeVisible" :fullscreen="isMinScreen" @opened="openedCharge"
            :close-on-click-modal="false" 
                width="600px">
            <zhuanyun-charge :id="chargeId" ref="chargeRef" @close-dg="chargeDg" />
        </el-dialog>

        <el-dialog :title="msg('导出选项')" :visible.sync="exportVisible" :fullscreen="isMinScreen" @opened="openedExportTypeSort"
            :close-on-click-modal="false" 
                width="600px">
            <export-type :expcom="expcomType" :ids="exportIds" ref="exportRef" @close-dg="closeExportDg" />
        </el-dialog>

        <el-dialog :title="msg('出货统计')" :visible.sync="exportTjVisible" :fullscreen="isMinScreen" @opened="openedExpTjSort"
            :close-on-click-modal="false" 
                width="600px">
            <export-tongji ref="exportTjRef" @close-dg="exportTjDg" />
        </el-dialog>

        <el-dialog :title="msg('出货时间')" :visible.sync="weightTimeVisible" :fullscreen="isMinScreen" @opened="openedWeightTime"
            :close-on-click-modal="false" 
                width="600px">
            <stock-weight-time :ids="weightTimeIds" ref="weightTimeRef" @close-dg="weightTimeDg" />
        </el-dialog>

        <el-dialog :title="msg('打印实名单')" :visible.sync="printPkgVisiable" :fullscreen="isMinScreen"  @opened="openPrintPkgDg"
            :close-on-click-modal="false" 
                width="600px" >
            <print-pkg-ticket ref="printPkgDg" :ids="pkgTicketIds"  @close-dg="closePrintPkgDg"/>
        </el-dialog> 

        <el-dialog :title="msg('自动打印实名发票单')" :visible.sync="printPkgVisiableAuto" :fullscreen="isMinScreen"  @opened="openPrintPkgDgAuto"
            :close-on-click-modal="false" 
                width="600px" >
            <print-pkg-ticket-auto ref="printPkgDgAuto" @close-dg="closePrintPkgDgAuto"/>
        </el-dialog> 

        <el-dialog :title="msg('打印发票')" :visible.sync="printPkgVisiableAutoP" :fullscreen="isMinScreen"  @opened="openPrintPkgDgAutoP"
            :close-on-click-modal="false" 
                width="600px" >
            <print-pkg-ticket-auto-p ref="printPkgDgAutoP" @close-dg="closePrintPkgDgAutoP"/>
        </el-dialog>

        <el-dialog :title="msg('打印实名发票')" :visible.sync="printRealVisiable" :fullscreen="isMinScreen"  @opened="openPrintRealDg"
            :close-on-click-modal="false" 
                width="600px" >
            <print-real-name-ticket ref="printRealDg" :ids="ids"  @close-dg="closePrintRealDg"/>
        </el-dialog> 

        <el-dialog :title="msg('打印标签')" v-if="printTagVisible" :visible.sync="printTagVisible1" :fullscreen="isMinScreen"
            :close-on-click-modal="false" @closed="printTagVisible=false"
                width="600px" >
            <print-tag ref="printTagDg" :ids="ids" />
        </el-dialog>

        <el-dialog :title="msg('打印库签')" :visible.sync="printKuTagVisible" :fullscreen="isMinScreen" @opened="openPrintKuTagDg"
            :close-on-click-modal="false"
                width="600px" >
            <print-ku-tag ref="printKuTagDg" :ids="ids" @close-dg="closePrintKuTagDg"/>
        </el-dialog>


        <el-dialog :title="msg('打印包裹单')" v-if="printBagVisible" :visible.sync="printBagVisible1" :fullscreen="isMinScreen"
            :close-on-click-modal="false" @closed="printBagVisible=false"
                width="600px" >
            <print-bag ref="printBagDg" :ids="ids" />
        </el-dialog> 

        <el-dialog :title="msg('更新收费方式')" :visible.sync="transitTypeVisible" :fullscreen="isMinScreen" @opened="openedTransitType"
            :close-on-click-modal="false" 
                width="650px">
            <stock-transit ref="transitTypeRef" :ids="transitIds" @close-dg="transitTypeDg" />
        </el-dialog>
        
        <el-dialog :title="msg('新建工单')" :visible.sync="createWorkOrderVisible" :fullscreen="isMinScreen" :close-on-click-modal="false">
          <work-order-add :workorder="workOrder" v-on:close-dg="closeWorkOrderAddDialog" ref="WorkOrderAdd"/>
        </el-dialog>

        <el-dialog :title="msg('验证个人安全密码')" :visible.sync="strongPwdVisiable" :close-on-click-modal="false">
          <strong-pwd v-on:close-dg="kit.strongAuthData.closeEvent"/>
        </el-dialog>

        <el-dialog width="600px" :title="msg('申报校对')" :visible.sync="declareCheckVisible" :fullscreen="isMinScreen" @opened="openedDeclareCheck"
        :close-on-click-modal="false">
          <stock-declare-check v-on:close-dg="closeStockDeclareCheckDialog" ref="declareCheck"/>
        </el-dialog>

        <el-dialog
            :title="msg('选择黑貓出货日期')"
            :visible.sync="shipDateVisiable"
            :close-on-click-modal="false"
            width="500px">
            <el-form label-width="150px">
                <el-row>
                    <el-tag effect="dark" type="success" style="margin-bottom:10px;">请选择出货日期，台湾黑貓节假日及周日不收货，请选择合适的日期</el-tag>
                    <el-col :xs="24" :sm="24">
                        <el-form-item :label="msg('黑貓出货日期')" label-width="120px">
                            <el-date-picker
                                v-model="shipDate"
                                :picker-options="pickerOptions"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div style="text-align:center; margin-top: 15px;">
                <el-button type="primary" size="mini"  @click="shipDateVisiableSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
                <el-button @click="shipDateVisiable = false">{{msg('取消')}}</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="msg('货物转寄')" :visible.sync="matchVisible" :fullscreen="isMinScreen" width="600px">
            <div style="text-align:center;">
                <div>
                    <el-tag type="danger">温馨提醒：请选择转寄方式，人工转寄需要手动操作，定时转寄需要设置；</el-tag>
                </div>
                <div style="margin:20px 0;padding:0px 20px;">
                    <!-- <el-radio v-model="matchRadio" :label="1" border size="mini">人工转寄</el-radio>
                    <el-radio v-model="matchRadio" :label="2" border size="mini">定时转寄</el-radio> -->
                    <el-button type="primary" plain  @click="matchSubmit(0)">{{msg('人工转寄')}}</el-button>
                    <el-button type="primary" plain  @click="matchSubmit(1)">{{msg('定时转寄')}}</el-button>
                </div>
                <!-- <div style="margin-top: 20px;">
                    <el-button type="primary" size="mini"  @click="matchSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
                    <el-button  size="mini" v-on:click="matchVisible = false">{{msg('取消')}}</el-button>
                </div> -->
            </div>
        </el-dialog>

        <el-dialog
            :title="msg('提示')"
            :visible.sync="cancelOrderVisible"
            :close-on-click-modal="false"
            width="500px">
            <div style="display:flex; align-items:flex-start;">
                <i class="el-icon-warning" style="color:#E6A23C; font-size:22px; margin-right:10px; margin-top:2px;"></i>
                <div style="flex:1;">
                    <div style="margin-bottom: 12px;">{{msg('确定要取消所选订单吗?')}}</div>
                    <el-checkbox v-model="cancelOrderSyncShopee">同步取消虾皮店铺订单<span style="color:#F56C6C;">【取消后无法恢复，请谨慎操作】</span></el-checkbox>
                    <div v-if="cancelOrderSyncShopee" style="margin-top: 10px;">
                        <el-radio-group v-model="cancelOrderShopeeReason">
                            <el-radio style="padding:10px" :label="1">和买家达成取消协议(CUSTOMER_REQUEST)</el-radio>
                            <el-radio style="padding:10px" :label="2">无法配达(UNDELIVERABLE_AREA)</el-radio>
                            <el-radio style="padding:10px" :label="3">不支持货到付款(COD_NOT_SUPPORTED)</el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelOrderVisible = false">{{msg('取消')}}</el-button>
                <el-button type="primary" @click="submitCancelOrderDialog()">{{msg('确定')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog
            :title="msg('处理取消申请')"
            :visible.sync="handelCancelVisible"
            :close-on-click-modal="false"
            width="400px">
            <el-form label-width="100px">
                <el-form-item :label="msg('处理结果：')">
                    <el-radio-group v-model="handelCancelDecision">
                        <el-radio :label="1">{{msg('同意')}}</el-radio>
                        <el-radio :label="2">{{msg('拒绝')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handelCancelVisible = false">{{msg('取消')}}</el-button>
                <el-button type="primary" @click="submitHandleCancel()">{{msg('确定')}}</el-button>
            </span>
        </el-dialog>

        <!--end dialog-->

    </div>

</template>

<script>

import StrongPwd from "@/views/sys/StrongPwd.vue";
import WorkOrderAdd from "@/views/sys/WorkOrderAdd.vue";
import axios from "axios";
import CtrlBox from "../../components/CtrlBox.vue";
import Pagenator from "../../components/Pagination.vue";
import QueryBox from "../../components/QueryBox.vue";
import ViewSelector from "../../components/ViewSelector.vue";
import XmDrawer from "../../components/XmDrawer.vue";
import InnerExpCodeDg from "../inventory/InnerExpCodeExpress.vue";
import InventoryTrace from "../inventory/InventoryTrace.vue";
import StockStartPkgType from "../order/StockStartPkgType.vue";
import SyncExpress from "../order/SyncExpress.vue";
import PrintCustomDialog from "../print/PrintCustomDialog.vue";
import AutoPkgCode from "./AutoPkgCode.vue";
import ExpCodeCheck from "./ExpCodeCheck.vue";
import ExpCodeInput from "./ExpCodeInput.vue";
import ReturnCodeInput from "./ReturnCodeInput.vue";
import ExportTihuo from "./ExportTihuo.vue";
import ExportTongji from "./ExportTongji.vue";
import ExportType from "./ExportType.vue";
import ExpressSorting from "./ExpressSorting.vue";
import Handover from './Handover.vue';
import PkgCode from "./InsertPkgCode.vue";
import PackInput from "./PackInput.vue";
import PrintPkgTicket from "./PrintPkgTicket.vue";
import PrintPkgTicketAuto from "./PrintPkgTicketAuto.vue";
import PrintPkgTicketAutoP from "./PrintPkgTicketAutoP.vue";
import PrintRealNameTicket from "./PrintRealNameTicket.vue";
import QijianHandle from "./QijianHandle.vue";
import StockAddPkg from "./StockAddPkg.vue";
import StockBatchUpdate from "./StockBatchUpdate.vue";
import StockBatchUpdateNew from "./StockBatchUpdateNew.vue";
import StockColumn from "./StockColumn.js";
import StockDeclareCheck from "./StockDeclareCheck.vue";
import Edit from "./StockEdit.vue";
import StockPageImport from "./StockPageImport.vue";
import StockPageOnlyImport from "./StockPageOnlyImport.vue";
import StockPageView from "./StockPageView.vue";
import StockPkgType from "./StockPkgType.vue";
import StockPrint from "./StockPrint.vue";
import StockPrint2 from "./StockPrint2.vue";
import StockPrint3 from "./StockPrint3.vue";
import StockPrint4 from "./StockPrint4.vue";
import StockPrint5 from "./StockPrint5.vue";
import StockPrint6 from "./StockPrint6.vue";
import StockPrint7 from "./StockPrint7.vue";
import StockPrint8 from "./StockPrint8.vue";
import PrintBag from './StockPrintBag.vue';
import StockPrintFind from "./StockPrintFind.vue";
import PrintKuTag from './StockPrintKuTag.vue';
import StockPrintPkgCode from "./StockPrintPkgCode.vue";
import StockPrintPkgPage from "./StockPrintPkgPage.vue";
import PrintTag from './StockPrintTag.vue';
import PrintTag2 from './StockPrintTag2.vue';
import StockReceive from "./StockReceive.vue";
import {exportStocks} from "./StockExportService.js";
import ExportByKeyword from "./ExportByKeyword.vue";
import {
batchSendOrderNew,
deleteStock,
doUpdatePkgType,
finishPakage,
markOrderGoodType,
openWindowWithPost,
trackExpress,
updateOutType,
getStocks,
readyQueryParam,
formatAmt
} from "./StockService.js";
import StockSorting from "./StockSorting.vue";
import SyncOrder from "./StockSyncOrder.vue";
import Trace from "./StockTrace.vue";
import StockTransit from './StockTransitDialog.vue';
import StockWeightShare from "./StockWeightShare.vue";
import StockWeightTime from './StockWeightTime.vue';
import ZhuanPkg from "./Zhuanyun.vue";
import ZhuanyunCharge from "./ZhuanyunCharge.vue";
import OrderSplitDialog from "../order/OrderSplitDialog.vue";

export default {
    name: 'Stock',
    components: {
      StrongPwd,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
        Pagenator:Pagenator,
        Edit:Edit,
        Drawer : XmDrawer,
        StockPageImport : StockPageImport,
        StockPageOnlyImport:StockPageOnlyImport,
        BatchUpdate: StockBatchUpdate,
        BatchUpdateNew: StockBatchUpdateNew,
        PageView: StockPageView,
        StockAddPkg: StockAddPkg,
        StockWeightShare:StockWeightShare,
        ZhuanPkg:ZhuanPkg,
        StockPrint: StockPrint,
        StockPrint2:StockPrint2,
        StockPrint3:StockPrint3,
        StockPrint4:StockPrint4,
        StockPrint5:StockPrint5,
        StockPrint6:StockPrint6,
        StockPrint7:StockPrint7,
        StockPrint8:StockPrint8,
        SyncOrder: SyncOrder,
        Trace: Trace,
        PkgCode:PkgCode,
        AutoPkgCode:AutoPkgCode,
        StockPrintFind:StockPrintFind,
        StockPrintPkgCode:StockPrintPkgCode,
        StockPrintPkgPage:StockPrintPkgPage,
        ExportTihuo:ExportTihuo,
        StockPkgType:StockPkgType,
        StockReceive:StockReceive,
        ExpressSorting:ExpressSorting,
        ExportType:ExportType,
        ExportTongji:ExportTongji,
        PrintPkgTicket:PrintPkgTicket,
        PrintPkgTicketAuto:PrintPkgTicketAuto,
        PrintPkgTicketAutoP:PrintPkgTicketAutoP,
        PrintRealNameTicket:PrintRealNameTicket,
        StockSorting:StockSorting,
        QijianHandle:QijianHandle,
        PrintTag:PrintTag,
        PrintTag2:PrintTag2,
        PrintKuTag:PrintKuTag,
        PrintBag:PrintBag,
        StockTransit:StockTransit,
        ExpCodeInput:ExpCodeInput,
        ReturnCodeInput:ReturnCodeInput,
        PackInput:PackInput,
        ExpCodeCheck:ExpCodeCheck,
        ZhuanyunCharge:ZhuanyunCharge,
        StockWeightTime:StockWeightTime,
        InnerExpCodeDg:InnerExpCodeDg,
        Handover:Handover,
        WorkOrderAdd: WorkOrderAdd,
        PrintCustomDialog:PrintCustomDialog,
        StockDeclareCheck:StockDeclareCheck,
        StockStartPkgType:StockStartPkgType,
        InventoryTrace:InventoryTrace,
        ViewSelector:ViewSelector,
        SyncExpress:SyncExpress,
        ExportByKeyword: ExportByKeyword,
        OrderSplitDialog: OrderSplitDialog
    },
    mounted(){
        this.user  = JSON.parse(localStorage.getItem("user"));
        this.initPage();

        this.$nextTick(()=>{
            window.stockTable = this.$refs.dataTable;
            
            // this.$refs.pageBox.addEventListener('scroll', ()=>{
            //     this.$refs.pageBox.scroll( ()=>{
            //         console.log("11");
            //     })
            // }, true)

            // 获取指定元素
            const scrollview = this.$refs['pageBox']
            scrollview.addEventListener('scroll', ()=>{
                // console.log("滚动中");
            }, true);

        });
    },
    data(){
        return {
            query:{
                history: 0, //是否查询历史纪录： 0-正常，1-查询
                length: 20, //每页显示的长度
                start: 0, //起始数量
                pageTotal:0,//总记录数
                pageIndex: 1,
                queries: [],
                store: false, //是否将其作为仓储视图
            },
            showQuery: false,
            isStore:null,
           
            columns: [],  //列配置
            genColumns: [], //生成的列配置
            viewSetting: null,
            originCols: null,

            datas: [],      //展示列表
            printPkgVisiable:false,
            printPkgVisiableAuto:false,
            printPkgVisiableAutoP:false,
            printRealVisiable:false,
            printRealType:null,
            dgTitle: '',
            dgVisible: false,
            curr: null,
            detailEditable: false,
            expCodeEdit:false,
            antOrderEdit:false,
            batchUpdateVisible: false,
            batchUpdateNewVisible:false,
            zhuanyunChargeVisible:false,
            chargeId:null,
            batchDatas: [],

            imgVisiable: false,
            pageId: null,  //面单id

            pkgTypeIds:null,

            addPkgIds:null,

            printCtrls: [],  //要打印的类型列表
            printDgVisible4:false,

            qijianVisible:false,

            pkgCodeVisible:false,//包号录入
            packageVisible:false,//扫码打包
            printFindVisible:false,//打印找货单
            printPkgCodeVisible:false,//按包号找货
            printPkgPageVisible:false,//待贴单包裹
            exportVisiable:false,//提货表

            receiveVisible:false,//通知收件选择仓库
            receiveIds:null,

            expCodeVisible:false,//录查询码
            returnCodeVisible:false,//录退件码
            actualCodeVisible:false,//扫码找货
            jiaojieVisible:false,//货物交接
            packVisible:false,//代打包登记
            exportVisible:false,
            exportType:null,//导出的类型 就是点击了那个导出按钮
            exportParams:null,//导出的条件
            exportIds:null,//导出选择的id
            exportTjVisible:false,//出货统计
            weightTimeVisible:false,
            weightTimeIds:null,

            colsPopVisible: false, //字段选择弹窗
            expcomType:null,//导出黑猫派件资料选择配送方式参数
            tihuoPkgCodes:'',//导出提货表袋号

            ids:null,//选中的id, 实名单ids
            pkgTicketIds:null,//装袋单ids

            printTagVisible: false,
            printTagVisible1: false,
            printKuTagVisible:false,
            printBagVisible: false,
            printBagVisible1: false,
            transitTypeVisible:false,//更新收费方式
            transitIds:null,//收费方式参数
            scanCode:null,
            shipDateVisiable:false,
            shipDate:null,
            pickerOptions:null,

            emptyFixedBoxHeight: '37px',

            matchVisible:false,
            handelCancelVisible:false,
            handelCancelDecision:null,
            cancelOrderVisible:false,
            cancelOrderSyncShopee:false,
            cancelOrderShopeeReason:null,

            createWorkOrderVisible:false, //提交工单
            workOrder: null,
            expCompanys:[],
            strongPwdVisiable: false, //个人安全密码验证窗
            declareCheckVisible:false, //申报校对弹窗
            declareCheckIds: '',
            exportConfig: {  //导出配置
                //判断是否设置过个人密码
                //执行正常操作
                remote: true,
                modes: ['current', 'selected', 'all'],
                types: ['xlsx'],
                exportMethod: ({options})=>{
                    // console.log(options);
                    exportStocks(this.exportType, options, this.query, this.originCols, this.isStore);
                    
                    return new Promise(resolve => {
                        resolve([])
                    });
                }
            },
        }
    },
    directives: {
        reheight: {
            bind(el, binding) {
                let height = '';
                function isReheight() {
                    const style = document.defaultView.getComputedStyle(el);
                    if (height !== style.height) {
                    binding.value(style.height);
                    }
                    height = style.height;
                }
                el.__vueSetInterval__ = setInterval(isReheight, 300);
            },
            unbind(el) {
                clearInterval(el.__vueSetInterval__);
            }
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 210;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods:{
        //初始化页面
        initPage(){
            // console.log(this.$route.query);

            let codes = this.$route.query['codes'];
            let type = this.$route.query['type'];
            if(!type){
                this.$refs.viewSelectofRef.getDefaultView(this.getViewCallback);
            }else{
                let id = 695; //财务专用视图
                if(this.viewSetting && this.viewSetting.id == id){
                    this.initDefQuery(codes, type);
                    this.list(true);
                }else{
                    this.$refs.viewSelectofRef.getDefaultView(this.getViewCallback, id);
                }
            }
           this.getCompanys();
        },
        getViewCallback(view){
            if(view && view.details){
                this.buildColumns(view.details);
            }
            if(view && view.queries){
                this.buildQueries(view.queries);
            }
            this.viewSetting = view;
            this.query.store = view.specFlag ? true:false;
            this.list(true);
        },

        initDefQuery(code, type){
            let col = null;
            if(type==3){ //transit_code, //pay_in_code, //lipei_code
                col = this.query.queries.find(e => e.colName == 'transit_code');
            }else if(type == 4){
                col = this.query.queries.find(e => e.colName == 'pay_in_code');
            }else if(type == 5){
                col = this.query.queries.find(e => e.colName == 'lipei_code');
            }
            if(col)
                col['dvalue'] = code;
        },
        getCompanys(){
            this.$axios.get(this.$kit.api.getExpCompany)
                .then((result)=> {
                    if(result.status){
                        this.expCompanys = result.data;
                    }
                });
        },
        
        //初始化表格
        buildColumns(details){
            this.columns =  StockColumn.buildColumns(this.$createElement,this,details);
           
            this.originCols = details.map(e =>  {
                return {
                    tableName : e.tableName,
                    colName: e.colName,
                    fieldName: e.fieldName,
                    hasAlias: e.hasAlias,
                    tableAlias: e.tableAlias
                }
            });

            setTimeout(() => {
                this.$nextTick(() => {
                    this.genColumns = this.$refs.dataTable.getColumns()
                })
            }, 1000);
            

        },
        //初始化查询条件
        buildQueries(qs){

            if(qs.findIndex(q => q.colName == 'allcode') == -1){
                qs.push({
                    colName: "allcode",
                    disabled: 0,
                    label: this.msg("快速批查"),
                    op: 6,
                    seq: 0,
                    tableAlias: "t",
                    tableName: "t_stock",
                    type: 0,
                    optType: 1,
                });
            }
          
            if(qs.findIndex(q => q.colName == 'alllikecode') == -1){
                qs.push({
                    colName: "alllikecode",
                    disabled: 0,
                    label: this.msg("全局查询"),
                    op: 7,
                    seq: 0,
                    tableAlias: "t",
                    tableName: "t_stock",
                    type: 0,
                    optType: 1,
                });
            }

            qs.forEach(q => {

                if(q.dvalue || q.dvalue === 0){

                    if(q.type == 3){ //3-表示是时间类型
                        let curr = new Date();
                        let prevTime =  curr.getTime() - (q.dvalue * 24 * 3600 * 1000);
                        let prev;
                        if(q.dvalue == 1){
                            prev = curr;
                        }else{
                            prev = new Date(prevTime);
                        }
                        let nv = [this.$kit.fmtDate(prev), this.$kit.fmtDate(curr)];
                        this.$set(q,'dvalues',nv);
                    }else if(q.type == 4){//日期时间类型
                        let curr = new Date();
                        let prevTime =  curr.getTime() - (q.dvalue * 24 * 3600 * 1000);
                        let prev = new Date(prevTime);
                        let nv =  [this.$kit.fmtDateTime(prev), this.$kit.fmtDateTime(curr)];
                        this.$set(q,'dvalues',nv);
                    }else if(q.op == 6 || q.op == 8){ //表示可以有多个值
                        let nv = q.dvalue.split(",").map(s => {
                            if(((s*1)+"") != 'NaN'){
                                return s*1
                            }else{
                                return s;
                            }
                        });
                        this.$set(q,'dvalues',nv);
                    }else{
                        let val = q.dvalue;
                        let val1 = val*1;
                        q.dvalue = val1 || val;
                        this.$set(q,'dvalues', []);
                    }
                }else{
                    this.$set(q,'dvalues', []);
                }
            });
            this.query.queries = qs;
            return qs;
        },
        //点击视图，切换到指定视图
        changeViews(view){
            this.viewSetting = view;
            this.query.store = view.specFlag ==1 ? true:false;
            this.isStore = view.specFlag ==1 ? true:false;

            this.buildColumns(view.details);
            this.buildQueries(view.queries);
            this.list(true);
            this.$nextTick(() => {
                this.refreshCtrlBoxScroll();
            });
            
        },
        refreshCtrlBoxScroll(){
            try{
                const ctrlBox = this.$refs.ctrlBoxRef;
                const leftBox = ctrlBox && ctrlBox.$refs ? ctrlBox.$refs.leftBox : null;
                const wrap = leftBox && leftBox.$refs ? leftBox.$refs.wrap : null;
                if(wrap){
                    wrap.scrollLeft = 0;
                    wrap.scrollTop = 0;
                }
                if(leftBox && typeof leftBox.update === 'function'){
                    leftBox.update();
                }
            }catch(err){
                return;
            }
        },
        //获取列表数据
        list(refresh){
            let params = readyQueryParam(refresh, this.query, this.originCols, this.isStore);
            
            let getStockDatas = async () => {
                this.datas =  await getStocks(params, this.query.history);
            }

            getStockDatas();

            if(refresh){
                axios.request({
                    url: this.$kit.api.stock.listTotal,
                    method: 'post',
                    data: params,
                    headers: {"Content-Type":"application/json; charset=utf-8",
                        "X-Requested-With":"XMLHttpRequest",
                    },
                    withCredentials: true,
                }).then((result) => {
                    let res = result.data;
                    if(res.status){
                        let total = res.data;
                        // console.log("总条数为："+total);
                        this.query.pageTotal = total;
                    }
                });

            }
        },
        
        //重置查询条件
        reset(){
            this.$kit.clearQuery(this.query);
            if(this.query.queries){ 
                this.query.queries.forEach(e => {
                        if(e.disabled == 0){
                            if(e instanceof Array){
                                e.dvalues = [];
                            }else{
                                e.dvalues = null;
                            }
                            if(e.hasOwnProperty('dvalue')){
                                e.dvalue = null; 
                            }
                        }
                    }
                );
            }
        },
        //点击行，选中行
        clickRow({row,rowIndex, $event, column, columnIndex}){
            try{
                //如果点击checkbox 则不处理
            let className = $event.target.className || '';
            if(columnIndex == 1 ){  //查看，编辑，详情
                if(className.indexOf('view-cell')>-1){
                    var _this = this;
                      //执行正常操作
                    _this.doEditRow(row);
                }else if(className.indexOf('remove-cell')>-1){
                    this.datas.splice(rowIndex, 1);
                }
            }else if(column.property == 'pageId'){  //执行查看面单
                if(row.pageId){
                    this.imgVisiable = true;
                    this.pageId = row.pageId;
                }
            }else if(column.property == 'code'){  //打开预览详情
                if(className.indexOf('detail-cell')>-1){
                    // if(!this.hasPermission("stoce:openStockDetail")){
                    //     this.$message(this.msg('非超级会员，不能点击直接查看！'));
                    //     return;
                    // }
                    this.openDetail(row.id, row.queryHistory);
                }
            }else if(column.property == 'status'){//打开物流记录
                // if(!this.hasPermission("stoce:openStockTrack")){
                //     this.$message(this.msg('非超级会员，不能点击直接查看！'));
                //     return;
                // }
                if(className.indexOf('status-cell')>-1){
                    var table =  this.$refs.dataTable;
                    table.clearCheckboxRow();
                    table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))

                    var selectes = this.$refs.dataTable.getCheckboxRecords();
                    if(selectes.length>0){
                        let row = selectes[0];
                        this.$refs.traceRef.showTracks(row.id, row.queryHistory);
                    }

                }
            }
            }catch(error){
                console.log(error);
            }
        },
        //分页数据发生改变，回调事件：info[0]: 每页显示的数量，info[1]: 起始页
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            this.list();
        },
        //点击添加按钮
        doAdd(type){
            // this.$tabs.open ("/admin/stock/add");
            this.$router.push({ name: 'stockAdd', params: {type:type}});
        },
        async doEditRow(row){
            this.curr  = row;
            // if(!row['details']){
            this.$set(row,'details',[]);
            let result =  await this.$axios.get(this.$kit.api.stock.detail+"?id="+row.id);
            if(result.status){
                
                var ds = result.data;

                ds.forEach(d => {
                    d['thumbs'] = [];
                    d['visible'] = true;
                    if(d.productThumb){
                        d['thumbs'].push({
                            name: d.productThumb,
                            url: this.$kit.api.imgView+d.productThumb
                        });
                    }
                    if(d.productPrice){
                        d.productPrice = formatAmt(d.productPrice);
                    }
                });

                this.dgVisible = true;
                this.$set(row,'details',ds);
            }
        // }

        
        this.$axios.get(this.$kit.api.stock.getStockById+"?id="+row.id)
            .then((result) => {
                var ds = result.data;
                if(ds.status == 10 || ds.status >= 23){
                    this.detailEditable = false;
                }else{
                    this.detailEditable = true;
                }

                if(ds.status >= 13 && ds.status < 50){
                    this.expCodeEdit = true;
                }else{
                    this.expCodeEdit = false;
                }

                if(ds.status >= 13 && ds.status < 23){
                    this.antOrderEdit = true;
                }else{
                    this.antOrderEdit = false;
                }

                this.dgTitle = this.msg("编辑订单");
                this.dgVisible = true;

            })

            if(this.dgVisible){
                this.$nextTick(() => {
                    this.$refs.editDg.initForm();
                });
            }
        },
        //删除选中项
        doDelete(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            deleteStock(selectes.map(e => e.id).join(","), this.list)
        },
        doDeleteOne(){//单个删除
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length > 1){
                this.$message(this.msg('一次只能删除一条数据'));
                return;
            }
            this.$confirm(this.msg('是否要删除选择的订单?'), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                    this.$axios.post(this.$kit.api.stock.deleteOne+"?id="+selectes.map(e => e.id).join(","))
                        .then((result) => {
                            if(result.status){
                                this.list();
                                let oks = result.data.oks;
                                let errs = result.data.errs;
                                this.$message(this.msg('删除成功')+"："+oks);
                            }else{
                                this.$message(result.msg);
                            }
                        });
                }).catch((err) => {
                // console.log(err);
            });
        },
        doUpdateCompany(){
            if(this.user.deptPath.indexOf('/1/6265/3441')<0 && this.user.deptPath.indexOf('/1/6274/5015')<0){
                this.$message(this.msg('定制功能，请联系客服开通!'));
                return;
            }
            this.$confirm(this.msg('是否将卖家宅配全部更改为新竹?'), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                    this.$axios.post(this.$kit.api.stock.doUpdateCompany)
                        .then((result) => {
                            if(result.status){
                                this.list();
                                this.$message(result.msg || this.msg('更新成功'));
                            }else{
                                this.$message(result.msg || this.msg('更新失败'));
                            }
                        });
                }).catch((err) => {
                // console.log(err);
            });
        },
        pageImport(){//上传面单
            this.$refs.stockPageImport.showDialog();
        },
        showSelectTotal(){//总数
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            let total = 0;
            if(selectes.length > 0){
                total = selectes.length;
            }
            this.$message({message:'当前选中：'+total+"条",type:"success"});
        },
        //批量更新
        doBatchUpdate(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            if(selectes.length>5000){
                this.$message(this.msg('单次不能超过5000条数据'));
                return;
            }

            this.batchDatas = [];
            selectes.forEach(s =>  {
                this.batchDatas.push({
                    id: s.id,
                    key: s.code,
                    value: null,
                    label: null,
                    result: null
                });
            });
            this.batchUpdateVisible = true;
        },
        //批量更新-new
        doBatchUpdateNew(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            if(selectes.length>10000){
                this.$message(this.msg('单次不能超过10000条数据'));
                return;
            }

            this.batchDatas = [];
            selectes.forEach(s =>  {
                this.batchDatas.push({
                    id: s.id,
                    key: s.code,
                    value: null,
                    label: null,
                    result: null
                });
            });
            this.batchUpdateNewVisible = true;
        },
        closeBatchUpdateDialog(type){
            if(type){
                this.list();
            }
            this.batchUpdateVisible = false;
        },
        closeBatchUpdateNewDialog(type){
            if(type){
                this.list();
            }
            this.batchUpdateNewVisible = false;
        },
        closeEditDialog(type){
            if(type){
                this.list();
            }
            this.dgVisible = false;
        },
        doExport(){//导出当前页面
            // this.exportConfig = {
            //     modes: ['current', 'selected', 'all'],
            //     remote: false
            // }

            this.$refs.dataTable.openExport({
                isPrint: false
            });
        },
        doPagePicExport(){
          var selectes = this.$refs.dataTable.getCheckboxRecords();
          if (selectes.length == 0) {
            this.$message(this.msg('请选中一条数据进行操作'));
            return;
          }
          var ids = selectes.map(e => e.id).join(",");
          window.open(this.$kit.api.stock.pagePicExport + "?ids=" + ids, "_blank");
        },
        doInOut(){
            this.$tabs.open("/admin/stock/inout");
        },
        selectStock(){//货物转寄

            this.matchVisible = true;

            // var _this = this;
            // var selectes = this.$refs.dataTable.getCheckboxRecords();
            // if(selectes.length==0){
            //     this.$message(this.msg('请选中一条数据进行操作'));
            //     return;
            // }
            // _this.$router.push({ name: 'stockMatch', params: {ids: selectes.map(e => e.id)}});

        },
        matchSubmit(type){
            //0-人工转寄，1-定时转寄
            if(type == 0){
                var _this = this;
                var selectes = this.$refs.dataTable.getCheckboxRecords();
                if(selectes.length==0){
                    this.$message(this.msg('请选中一条数据进行操作'));
                    return;
                }
                this.matchVisible = false;
                _this.$router.push({ name: 'stockMatch', params: {ids: selectes.map(e => e.id)}});
            }else if(type == 1){
                //定时转寄
                this.$confirm("定时转寄为试用功能，请前往个人设置中开启货物定时转寄功能", this.msg('提示'), {
                    confirmButtonText: this.msg('确定'),
                    cancelButtonText: this.msg('取消'),
                    type: 'warning'
                })
            }
        },
        updatePkgTypeNew(){//代打包选择登记
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            var _this = this;

            this.$confirm("是否要对选中的订单进行打包登记?", this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {

                //判断当前选择的订单打单人字段是否全部于当前登录账号一致
                this.$axios.post(_this.$kit.api.stock.checkPrinter,selectes.map(e => e.id).join(","))
                    .then((result) => {
                        if(result.status){
                            _this.doUpdatePkgTypeNew(selectes);
                        }else{
                            this.$confirm("是非要继续对非本人打单的订单进行打包登记?", this.msg('提示'), {
                                confirmButtonText: this.msg('确定'),
                                cancelButtonText: this.msg('取消'),
                                type: 'warning'
                            }).then(() => {
                                _this.doUpdatePkgTypeNew(selectes);
                            }).catch((err) => {
                                _this.$message(_this.msg('取消操作'));
                            });
                        }
                    })

            }).catch((err) => {
                _this.$message(_this.msg('取消操作'));
            });

        },
        doUpdatePkgTypeNew(selectes){
            var _this = this;
            this.$axios.post(_this.$kit.api.updateColumn.updatePackType,selectes.map(e => e.id).join(","))
                .then((result) => {
                    if(result.status){
                        _this.$message(result.msg || _this.msg('更新成功'));
                        _this.list(false);
                    }else{
                        _this.$message(result.msg || _this.msg('更新失败'));
                    }
                })
        },
        openedReceive(){
            this.$nextTick(() => {
                this.$refs.receiveDg.init();
            });
        },
        closeReceiveDg(){
            this.receiveVisible = false;
            this.list(false);
        },
        doUpdateOutType(){//仓储贴单
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            updateOutType(selectes.map(s => s.id), ()=>{this.list(false)});
        },
        doFinishPakage(){//打包完成
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>200){
                this.$message(this.msg('单次最多选择200条'));
                return;
            }
            finishPakage(selectes.map(s => s.id), ()=>{this.list(false)});
        },
        addStockPkg(){//分包加单
            this.$refs.addAddPkgRef.showDialog();
        },
        closeAddPkgDialog(type){
            if(type){
                this.list();
            }
        },
        stockCheck(command){
          if (command == 'a') {
            this.$tabs.open("/admin/stock/check");//出货核对
          } else if (command == 'b') {
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length <= 0){
              this.$message.warning(this.msg('请选中一条数据进行操作'));
              return;
            }
            let ids = selectes.map(e => e.id).join(",");
            this.declareCheckIds = ids;
            this.declareCheckVisible = true;
          }
        },
        // checkCodeInStore(){//扫码入库
        //     this.$tabs.open("/admin/stock/checkCodeIn");
        // },
        stockErrAdd(){//异常通报
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            var _this = this;
            if(selectes.length > 0){
                let ids = selectes.map(e => e.id).join(",");
                // this.$router.push({ name: 'stockError', params: {ids:ids}});
                window.localStorage.setItem("errAddIds", ids);
                this.$tabs.open("/admin/stock/error");
            }else{
                window.localStorage.setItem("errAddIds", null);
                this.$tabs.open("/admin/stock/error");
                // this.$router.push({ name: 'stockError', params: {ids:''}});
            }
        },
        workOrderAdd(){//提交工单
          var selectes = this.$refs.dataTable.getCheckboxRecords();

          if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

          var _this = this;

          this.workOrder = {
            id:null,
            typeName:null,
            level:0,
            title:null,
            description:null,
            handlerId:null,
          }
          if(selectes.length > 0){
            let orderNos = selectes.map(e => e.code).join(",");
            var orderList = [];
            for (var i = 0; i < selectes.length; i++) {
              var tmp = {
                stockId: selectes[i].id,
                stockCode: selectes[i].code,
                stockOwner: selectes[i].owner
              };
              orderList.push(tmp);
            }
            this.workOrder.orderList = orderList;
            //this.workOrder.description = orderNos + '订单编号';
          }

          this.createWorkOrderVisible = true;
        },
        scanCodeFun(){//扫码找货
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length > 1){
                this.$message(this.msg('只能选中一条数据进行操作'));
                return;
            }
            if(selectes.length > 0){
                let stock = selectes[0];
                this.scanCode = stock.code;
            }else{
                this.scanCode = null
            }
            this.actualCodeVisible = true;
        },
        handover(){//货物交接
            this.jiaojieVisible = true;
        },
        receiveStock(){//通知收件
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            var _this = this;
            this.$axios.post(_this.$kit.api.stock.getStockByIds,selectes.map(e => e.id).join(","))
                .then((result) => {
                    selectes.splice(0,selectes.length);
                    selectes = result.data;
                    let msg = '';
                    for(let i=0;i<selectes.length;i++){
                        let e = selectes[i];
                        if(e.expPageStatus != 15){
                            msg += e.code+',';
                        }
                        if(e.status > 35){
                            _this.$message(e.code + _this.msg('已出货，不能通知收件'));
                            return;
                        }
                        if(e.isCancel == 1){
                            _this.$message(e.code + _this.msg('已取消，不能进行操作'));
                            return;
                        }
                    }
                    
                    if(msg){
                        _this.$confirm(_this.fmt('%s还没有打印面单进行贴单操作，是否继续执行发货让货运代为贴单?', [msg]), _this.msg('提示'), {
                            confirmButtonText: _this.msg('是'),
                            cancelButtonText: _this.msg('否'),
                            type: 'warning'
                        }).then(() => {

                            this.receiveIds = selectes.map(e => e.id).join(",");
                            this.receiveVisible = true;

                        }).catch((err) => {
                        // console.log(err);
                            _this.$message(_this.msg('取消操作'));
                        });
                    }else{

                        this.receiveIds = selectes.map(e => e.id).join(",");
                        this.receiveVisible = true;

                    }
                })
            
        },
        xuniReceiveStock(){//虚拟揽收
            var _this = this;
            let selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            _this.$confirm(_this.msg('是否将选中的订单虚拟揽收?'), _this.msg('提示'), {
                confirmButtonText: _this.msg('是'),
                cancelButtonText: _this.msg('否'),
                type: 'warning'
            }).then(() => {
                
                _this.$axios.post(_this.$kit.api.stock.xuniReceiveStock+"?ids="+selectes.map(e => e.id).join(","))
                .then((result) => {
                    _this.$message(result.msg);
                })

            }).catch((err) => {
                _this.$message(_this.msg('取消操作'));
            });
        },
        weightShare(){//重量分摊
            var _this = this;
            let selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$refs.weightShareRef.showDialog(selectes.map(e => e.id));
            
        },
        closeWeightShareDialog(type){
            if(type){
                this.list(true);
            }
        },
        //item: 2-取消，0-恢复
        cancel(item){//取消订单
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            var _this = this;

            this.$axios.post(_this.$kit.api.stock.getStockByIds,selectes.map(e => e.id).join(","))
                .then((result) => {
                    let data = result.data;
                    for(let i=0;i<data.length;i++){
                        let e = data[i];
                        if(e.expPageStatus >= 15 && e.status != 80){
                            this.$message(e.code+this.msg('面单已打印,不能取消订单,可在批量更新中更新异常处理为：待处理'));
                            return;
                        }
                        if(e.isCancel == 2 && item == 2){
                            _this.$message(e.code+this.msg('已取消，不能进行操作'));
                            return;
                        }
                        if(e.isCancel == 0 && item == 0){
                            _this.$message(e.code+this.msg('未取消订单不能恢复'));
                            return;
                        }
                    }

                    let msg = '';
                    if(item == 2){
                        msg = this.msg('确定要取消所选订单吗?');
                    }else{
                        msg = this.msg('确定要恢复所选订单吗?');
                    }
                    this.$confirm(msg, this.msg('提示'), {
                        confirmButtonText: this.msg('确定'),
                        cancelButtonText: this.msg('取消'),
                        type: 'warning'
                    }).then(() => {
                        _this.$axios.post(_this.$kit.api.updateColumn.updateCancel+'?value='+item,selectes.map(e => e.id).join(","))
                        .then((result) => {
                            if(result.status){
                                _this.$message(result.msg || _this.msg('更新成功'));
                                _this.list(false);
                            }else{
                                _this.$message(result.msg || _this.msg('更新失败'));
                            }
                        });
                    }).catch((err) => {
                        _this.$message(_this.msg('取消操作'));
                    });
                })

        },
        allowUpload(type){//通知上传面单
            //type=0 通知上传；type=1 取消上传
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            let msg = null;
            if(type == 0){
                msg = '确定要通知上传面单吗?';
            }else if(type == 1){
                msg = '确定要撤回通知吗？';
            }
            var _this = this;
            this.$confirm(this.msg(msg), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                let ids = selectes.map(e=>e.id).join(',');
                _this.$axios.post(_this.$kit.api.stock.allowUpload,
                    {
                        type:type,
                        id:ids
                    }
                    ).then((result) => {
                        _this.$message(result.msg || _this.msg('更新成功'));
                        _this.list(true);
                    });
            }).catch((err) => {
                // console.log(err);
            });
        },
        stockEditStatus(){//待备货
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            var _this = this;

            this.$axios.post(_this.$kit.api.stock.getStockByIds,selectes.map(e => e.id).join(","))
                .then((result) => {
                    let data = result.data;
                    let ok = true;
                    for(let i=0;i<data.length;i++){
                        let e = data[i];
                        if(e.status < 15 || e.status > 25){
                            ok = false;
                        }
                    }
                    if(!ok){
                        this.$message(this.msg('已打包完成的订单不能恢复到待备货状态'));
                        return;
                    }

                    this.$confirm(this.msg('确定要将选中订单改为待备货吗？'), this.msg('提示'), {
                        confirmButtonText: this.msg('确定'),
                        cancelButtonText: this.msg('取消'),
                        type: 'warning'
                    }).then(() => {
                        _this.$axios.post(_this.$kit.api.updateColumn.updateStatus,selectes.map(e => e.id).join(","))
                        .then((result) => {
                            if(result.status){
                                _this.$message(result.msg || _this.msg('更新成功'));
                                _this.list(false);
                            }else{
                                _this.$message(result.msg || _this.msg('更新失败'));
                            }
                        });
                    }).catch((err) => {
                        _this.$message(_this.msg('取消操作'));
                    });
                })
        },
        zhuanyunPkg(type){//集运转运&&包裹回寄
            var _this = this;
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$axios.post(_this.$kit.api.stock.getZhuanyunByIds+"?ids="+selectes.map(e => e.id).join(","))
                .then((result) => {
                    let data = result.data;
                    let sta = true;//不符合状态
                    let cancel = true;//取消订单
                    let store = true;//同仓库
                    let owne = true;//同归属人
                    for(let i=0;i<data.length;i++){
                        let e = data[i];
                        if(e.status != 10 && e.status != 85){
                            sta = false;
                            break;
                        }
                        if(e.isCancel == 1 && type == 1){
                            cancel = false;
                            break;
                        }
                        if(data[0].storeId != e.storeId){
                            store = false;
                        }
                        if(data[0].owner != e.owner){
                            owne = false;
                        }
                    }
                    let msg = "";
                    if(type == 0){
                        msg = "集运转运";
                    }else{
                        msg = "包裹回寄";
                    }
                    if(!sta){
                        _this.$message(_this.fmt('已入仓及已拆包状态才能进行%s',[msg]));
                        return;
                    }
                    if(!cancel){
                        _this.$message(_this.msg('已取消订单不能进行操作'));
                        return;
                    }
                    if(!store){
                        _this.$message(_this.msg('所选货物非同一仓库货物，请重新选择！'));
                        return;
                    }
                    if(!owne){
                        _this.$message(_this.msg('所选货物非同一归属人货物，请重新选择！'));
                        return;
                    }
                    
                    let title = "";
                    let type = 0;
                    

                    if(type==0){
                        title = '集运转运';
                        type = 0;
                    }else{
                        title = '包裹回寄';
                        type = 1;
                    }
                    this.$refs.zhuanyunRef.showDialog(selectes.map(s => s.id), title, type);
                })
        },
        qijianHandle(){//弃件处理
            var _this = this;
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$axios.post(_this.$kit.api.stock.getZhuanyunByIds+"?ids="+selectes.map(e => e.id).join(","))
                .then((result) => {
                    let data = result.data;
                    let sta = true;//不符合状态
                    let store = true;//同仓库
                    for(let i=0;i<data.length;i++){
                        let e = data[i];
                        if(e.status != 10 && e.status != 85){
                            sta = false;
                            break;
                        }
                        if(data[0].storeId != e.storeId){
                            store = false;
                        }
                    }
                    if(!sta){
                        _this.$message(_this.msg('已入仓及已拆包状态才能进行弃件操作'));
                        return;
                    }
                    if(!store){
                        _this.$message(_this.msg('所选货物非同一仓库货物，请重新选择！'));
                        return;
                    }
                    let total = selectes.length;
                    _this.$confirm(_this.fmt('请问是否要将这%s票货物作弃件处理？', [total]), '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        _this.qijianVisible = true;
                    }).catch(() => {
                        _this.$message({
                            type: 'info',
                            message: '取消操作'
                        });          
                    });
                })
        },
        closeQijianDialog(){
            this.qijianVisible = false;
        },
        handlePrintOne(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>1){
                this.$message(this.msg('只能选中一条数据'));
                return;
            }
            this.printCtrls = [1];
            this.$refs.printDg.preparePrint([selectes[0].id], this.printCtrls);
        },
        handlePrint(command){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0 && command != 'o'){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            var visibleData = this.$refs.dataTable.getTableData().visibleData;
            //排序
            var sorts = [];
            visibleData.forEach(item => {
                let exist = selectes.findIndex(s => s.id === item.id);
                if(exist>-1){
                    sorts.push(item);
                }
            });
            selectes = sorts;

            // console.log(selectes);

            if(command== 'custom'){
                this.$refs.PrintCustomDialogRef.showDialog(selectes.map(s=>s.id));
            }else if(command == 'a'){
                this.printCtrls = [1];
                //var selectes = this.$refs.dataTable.getCheckboxRecords();
                this.$refs.printDg.preparePrint(selectes.map(s=>s.id), this.printCtrls);
            }else if(command == 'y'){
                this.printCtrls = [1];
                this.$refs.printDg2.showDialog(selectes.map(s=>s.id), this.printCtrls,0, this.isMinScreen);
            }else if(command == 'z'){
                this.printCtrls = [1];
                this.$refs.printDg3.showDialog(selectes.map(s=>s.id), this.printCtrls,this.isMinScreen);
            }else if(command == 'r'){
                //打印打印拣货单&自定义快递单
                this.printCtrls = [1];
                if(selectes.length>0){
                    this.$refs.printDg4.preparePrint(selectes.map(s=>s.id), this.printCtrls);
                }
            }else if(command == 'l'){
                //打印自定义快递单
                this.printCtrls = [1];
                if(selectes.length>0){
                    this.$refs.printDg6.preparePrint(selectes.map(s=>s.id), this.printCtrls);
                }
                
            }else if(command == 'v'){
                //打印中通快递单
                this.printCtrls = [1];
                this.$refs.printDg7.showDialog(selectes.map(s=>s.id), this.printCtrls,this.isMinScreen);
            }else if(command == 'w'){
                //打印拣货单&中通快递单
                this.printCtrls = [1];
                this.$refs.printDg8.showDialog(selectes.map(s=>s.id), this.printCtrls,this.isMinScreen);
            }else if(command == 's'){
                //打印拣货单&查询码
                this.printCtrls = [1];
                this.$refs.printDg5.showDialog(selectes.map(s=>s.id), this.printCtrls, this.isMinScreen);
            }else if(command == 'b'){
                //打印面单
                this.printCtrls = [0];
                this.$refs.printDg.preparePrint(selectes.map(s=>s.id), this.printCtrls);

            }
            else if(command == 'c'){
                //打印货物图
                this.printCtrls = [3];
                this.$refs.printDg.preparePrint(selectes.map(s=>s.id), this.printCtrls);
            }else if(command == 'd'){
                //打印货单&面单
                this.printCtrls = [1,0];

                if(this.user.deptPath.indexOf('/1/6262/')<0 && !this.hasPermission('stock:printMiandan')){
                    this.$message(this.msg('抱歉，会员权限不够，请升级会员!'));
                    return;
                }

                //非会员只能单张打印
                if(this.user.vip == 0 && selectes.length > 1){
                    this.$message(this.msg('非会员，只能单张打印！'));
                    return;
                }
                this.$refs.printDg.preparePrint(selectes.map(s=>s.id), this.printCtrls);
            }else if(command == 'e'){
                this.printCtrls = [1,3];
                this.$refs.printDg.preparePrint(selectes.map(s=>s.id), this.printCtrls);
            }else if(command == 'f'){

                if(this.user.deptPath.indexOf('/1/6262/')<0 && !this.hasPermission('stock:printMiandan')){
                    this.$message(this.msg('抱歉，会员权限不够，请升级会员!'));
                    return;
                }

                this.printCtrls = [0,3];
                this.$refs.printDg.preparePrint(selectes.map(s=>s.id), this.printCtrls);
            }else if(command == 'g'){
                
                if(this.user.deptPath.indexOf('/1/6262/')<0 && !this.hasPermission('stock:printMiandan')){
                    this.$message(this.msg('抱歉，会员权限不够，请升级会员!'));
                    return;
                }

                this.printCtrls = [0,1,3];
                //非会员只能单张打印
                if(this.user.vip == 0 && selectes.length > 1){
                    this.$message(this.msg('非会员，只能单张打印！'));
                    return;
                }
                this.$refs.printDg.preparePrint(selectes.map(s=>s.id), this.printCtrls);
            }
            // else if(command == 'h'){
            //     //打印实名单
            //     if(selectes && selectes.length > 0){
            //         this.pkgTicketIds = selectes.map(s=>s.id).join(",");
            //         this.$axios.post(this.$kit.api.stock.getStockByIds,selectes.map(e => e.id).join(","))
            //         .then((result) => {
            //             let data = result.data;
            //             for(let i=0;i<data.length;i++){
            //                 let e = data[i];
            //                 if(e.status != 13 && e.status != 23){
            //                     this.$message(e.code + this.msg('不是待备货或已打单状态'));
            //                     return;
            //                 }
            //             }
            //             this.printPkgVisiable = true;
            //         })
            //     }else{
            //         this.pkgTicketIds = null;
            //         this.printPkgVisiable = true;
            //     }
            // }
            // else if(command == 'j'){//自动打印实名发票单
            //     this.printPkgVisiableAuto = true;
            // }
            // else if(command == 'u'){//打印发票
            //     this.printPkgVisiableAutoP = true;
            // }
            // else if(command == 'm' || command == 'o'){
            //     //打印实名发票，打印网购货物发票
            //     this.printRealType = command;
            //     if(selectes && selectes.length > 0){
            //         this.ids = selectes.map(s=>s.id).join(",");
            //         this.$axios.post(this.$kit.api.stock.getStockByIds,selectes.map(e => e.id).join(","))
            //         .then((result) => {
            //             let data = result.data;
            //             for(let i=0;i<data.length;i++){
            //                 let e = data[i];
            //                 if(e.status != 13 && e.status != 23){
            //                     this.$message(e.code+this.msg('不是待备货或已打单状态'));
            //                     return;
            //                 }
            //             }
            //             this.printRealVisiable = true;
            //         })
            //     }else{
            //         this.ids = null;
            //         this.printRealVisiable = true;
            //     }
            // }
            else if(command ==  'n'){
                
                this.ids = selectes.map(s=>s.id).join(",");
                this.printTagVisible = true;
                this.printTagVisible1 = true;

            }else if(command ==  't'){
                
                let stockIds = selectes.map(s=>s.id).join(",");
                this.$refs.printTagDg2.showDialog(stockIds, this.isMinScreen);

            }else if(command ==  'q'){
                
                this.ids = selectes.map(s=>s.id).join(",");
                this.printKuTagVisible = true;

            }else if(command ==  'k'){
                this.ids = selectes.map(s=>s.id).join(",");
                this.printBagVisible = true;
                this.printBagVisible1 = true;
            }

        },
        printFinish(type){
            if(type){
                this.list(false);
            }
        },
        /*
        openedPrint(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$nextTick(() => {
                this.$refs.printDg.preparePrint(selectes.map(s=>s.id), this.printCtrls);
            });
        },
        */
        openedPrint1(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$nextTick(() => {
                this.$refs.printDg1.preparePrint(selectes.map(s=>s.id), this.printCtrls);
            });
        },
        openedQijian(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$nextTick(() => {
                this.$refs.qijianRef.init(selectes.map(s=>s.id),this.zhuanyunType);
            });
        },
        openedPkgCode(){//打开包号录入界面
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$nextTick(() => {
                this.$refs.pkgCodeDg.init(selectes.map(s=>s.id),selectes.length);
            });
        },
        pkgCodeClose(){
            this.pkgCodeVisible = false;
            this.list(false);
        },
        openedPackage(){//打开扫码打包
            this.$nextTick(() => {
                this.$refs.packageDg.init();
            });
        },
        openedFindPrint(){//转寄找货单
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$nextTick(() => {
                this.$refs.printFindDg.init(selectes.map(s=>s.id));
            });
        },
        openedPrintPkgCode(){//转运找货单
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$nextTick(() => {
                this.$refs.printPkgCodeDg.init(selectes.map(s=>s.id));
            });
        },
        handleInsertPkgCode(command){//打包
            if(command == 'a'){
                this.openPkgCode();//包号录入
            }else if(command == 'b'){
                this.autoPkgCode();//扫码打包
            }
        },
        handleImport(command){//导入
            if(command == 'a'){
                this.$tabs.open ("/admin/stock/import");//导入EXCEL
            }else if(command == 'b'){
                this.$refs.stockPageOnlyImport.showDialog();
            }
        },
        handleExport(command){//导出
            this.exportType = command;

            if(command == 'o'){
                this.$refs.ExportByKeywordRef.showDialog();
                return;
            }

            var params = this.$kit.rebuildQuery(this.query);
            //获取查询的数，并且过滤掉空数据，
            let queries = []; 
            this.query.queries.forEach(e => {
                    let values = e.dvalues;
                    let value = e.dvalue;
                    let q = {
                        dvalue: e.dvalue,
                        tableName: e.tableName,
                        colName: e.colName,
                        op: e.op,
                        type: e.type,
                        tableAlias: e.tableAlias
                    }

                    if(q.type == 0 && q.op == 6){
                        if(value){
                            value = value.split(/[\s,]+/);
                            q.dvalue = value.join(",");
                            queries.push(q);
                        }
                    }else{
                        if(q.type == 3 || q.op == 6){
                            if(values && values.length>0){
                                q.dvalue = values.join(",");
                                queries.push(q);
                            }
                        }else if(q.dvalue || q.dvalue === 0){
                            queries.push(q);
                        }
                    }
                });
            params['queries'] = queries;
            
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            let ids = '';
            if(selectes.length > 0){
                ids = selectes.map(s=>s.id).join(",");
            }

            var _this = this;
            if (command == 'a') {
              _this.doExport();
            }else if(command == 'b' || command == 'c' || command == 'd' || command == 'l'){//导出清关、航空、派件、报机
              //执行正常操作
              _this.exportVisible = true;
              _this.exportParams = params;
              _this.exportIds = ids;
              _this.expcomType = command;
            }else if(command == 'e'){//提货表
                //获取选中数据所对应的袋号
                if(ids){
                    this.$axios.post(this.$kit.api.stock.getPkgCodeByIds, ids)
                    .then((result) => {
                        let codes = result.data;
                        if(codes && codes.length > 0){
                            codes.forEach(code => {
                                this.tihuoPkgCodes += code+"\n";
                            })
                        }
                        this.exportVisiable = true;
                    })
                }else{
                    this.exportVisiable = true;
                }
            }else if(command == 'f'){//建单资料
                _this.$refs.dataTable.openExport({isPrint: false})
            }else if(command == 'g'){//出货统计
                this.exportTjVisible = true;
            }else if(command == 'h'){//导出详情
                openWindowWithPost(
                    this.$kit.api.export.exportDetail,
                    {
                        ids:ids,
                        history:this.query.history
                    }
                );
            }else if(command == 'j'){//导出物流记录
                openWindowWithPost(
                    this.$kit.api.export.exportStatus,
                    {
                        ids:ids,
                        history:this.query.history
                    }
                );
            }else if(command == 'k'){//导出采购详情
                openWindowWithPost(
                    this.$kit.api.export.exportBuyDetail,
                    {
                        ids:ids,
                        history:this.query.history
                    }
                );
            }else if(command == 'm'){//导出转寄成本
                openWindowWithPost(
                    this.$kit.api.export.exportResendCost,
                    {
                        ids:ids,
                        history:this.query.history
                    }
                );
            }else if(command == 'n'){//导出面单图片
                this.doPagePicExport();
            }
        },
        closeExportDg(data){
            var _this = this;
            this.exportVisible = false;

            if(!data.doExport){
                return;
            }
            if(this.exportType == 'b'){//导出清关资料
              _this.$kit.strongAuth(function () {
                openWindowWithPost(
                    _this.$kit.api.export.exportExp,
                    {
                      ids: _this.exportIds,
                      isMatch: data.isMatch,
                      expBatchs: data.expBatchs,
                      templateKey: data.templateKey,
                      baojiNameCount: data.baojiNameCount
                    }
                );
              }, _this);
                //  window.open(this.$kit.api.export.exportExp+"?data="+encodeURIComponent(JSON.stringify(this.exportParams))+"&ids="+this.exportIds+"&isMatch="+(data.isMatch?1:0),"_blank")
            }else if(this.exportType == 'c'){//导出航空资料
              _this.$kit.strongAuth(function () {
                openWindowWithPost(
                    _this.$kit.api.export.exportHangkong,
                    {
                        ids:_this.exportIds,
                        isMatch:data.isMatch,
                        expBatchs:data.expBatchs,
                    }
                );
              }, _this);
                // window.open(this.$kit.api.export.exportHangkong+"?data="+encodeURIComponent(JSON.stringify(this.exportParams))+"&ids="+this.exportIds+"&isMatch="+(data.isMatch?1:0),"_blank")
            }else if(this.exportType == 'd'){//导出黑猫派件资料
              _this.$kit.strongAuth(function () {
                openWindowWithPost(
                    _this.$kit.api.export.exportHeimao,
                    {
                      ids: _this.exportIds,
                      isMatch: data.isMatch,
                      expBatchs: data.expBatchs,
                      expCompany: data.expCompany
                    }
                );
              }, _this);
                // window.open(this.$kit.api.export.exportHeimao+"?data="+encodeURIComponent(JSON.stringify(this.exportParams))+"&ids="+this.exportIds+"&isMatch="+(data.isMatch?1:0),"_blank")
            }else if(this.exportType == 'l'){//导出报机资料
              _this.$kit.strongAuth(function () {
                openWindowWithPost(
                    _this.$kit.api.export.exportBaoJi,
                    {
                        ids:_this.exportIds,
                        isMatch:data.isMatch,
                        expBatchs:data.expBatchs,
                        baojiNameCount: data.baojiNameCount
                    }
                );
              }, _this);
                // window.open(this.$kit.api.export.exportHangkong+"?data="+encodeURIComponent(JSON.stringify(this.exportParams))+"&ids="+this.exportIds+"&isMatch="+(data.isMatch?1:0),"_blank")
            }
        },
        openExportDg(){
            this.$nextTick(() => {
                this.$refs.exportDg.init();
            });
        },
        openedExportTypeSort(){
            this.$nextTick(() => {
                this.$refs.exportRef.init();
            });
        },
        closeTihuoDg(data){
            this.exportVisiable = false;
            this.tihuoPkgCodes = '';
            let query = {
                codes:data.codes
            }
            var params = this.$kit.rebuildQuery(query);
            // window.location.href= this.$kit.api.export.exportTihuo+"?data="+encodeURIComponent(JSON.stringify(params));
            window.open(this.$kit.api.export.exportTihuo+"?data="+encodeURIComponent(JSON.stringify(params)), "_blank");
        },
        closePrintPkgDg(){
            this.printPkgVisiable = false;
        },
        closePrintPkgDgAuto(){
            this.printPkgVisiableAuto = false;
        },
        closePrintPkgDgAutoP(){
            this.printPkgVisiableAutoP = false;
        },
        closePrintRealDg(){
            this.printRealVisiable = false;
        },
        closePrintKuTagDg(){
            this.printKuTagVisible = false;
        },
        transitTypeDg(){
            this.transitTypeVisible = false;
        },
        handleFindTicket(command){//快速找货
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(command == 'a'){
                //转寄找货单
                if(selectes.length==0){
                    this.$message(this.msg('请选中一条数据进行操作'));
                    return;
                }
                this.printFindVisible = true;
            }else if(command == 'b'){
                // this.printPkgCodeVisible = true;//旧版--打印
                let ids = '';
                if(selectes.length > 0){
                    ids = selectes.map(e => e.id).join(",")
                }
                openWindowWithPost(//转运找货单--新版--导出
                    this.$kit.api.export.zhaohuoTicket,
                    {
                        ids:ids,
                    }
                );
            }else if(command == 'c'){
                this.printPkgPageVisible = true;//按贴单包裹
            }
        },
        openedPrintPkgPage(){
            this.$nextTick(() => {
                this.$refs.printPkgPageDg.init();
            });
        },
        handleAllowUpload(command){//通知上传面单
            if(command == 'a'){
                this.allowUpload(0);
            }else if(command == 'b'){
                this.allowUpload(1);
            }
        },
        handleCancel(command){//取消订单
            if(command == 'a'){
                this.openCancelOrderDialog();
            }else if(command == 'b'){
                this.cancel(0);
            }else if(command == 'c'){
                var selectes = this.$refs.dataTable.getCheckboxRecords();
                if(selectes.length==0 || selectes.length>1){
                    this.$message(this.msg('请选中一条数据进行操作'));
                    return;
                }
                this.handelCancelDecision = null;
                this.handelCancelVisible = true;
            }
        },
        openCancelOrderDialog(){
            this.cancelOrderSyncShopee = false;
            this.cancelOrderShopeeReason = null;
            this.cancelOrderVisible = true;
        },
        submitCancelOrderDialog(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(this.cancelOrderSyncShopee){
                if(!this.cancelOrderShopeeReason){
                    this.$message(this.msg('请选择取消原因'));
                    return;
                }
                if(selectes.length>1){
                    this.$message(this.msg('请选中一条数据进行操作'));
                    return;
                }
            }

            var _this = this;
            var idsStr = selectes.map(e => e.id).join(",");
            this.$axios.post(_this.$kit.api.stock.getStockByIds, idsStr)
                .then((result) => {
                    let data = result.data;
                    for(let i=0;i<data.length;i++){
                        let e = data[i];
                        if(e.expPageStatus >= 15 && e.status != 80){
                            this.$message(e.code+this.msg('面单已打印,不能取消订单,可在批量更新中更新异常处理为：待处理'));
                            return;
                        }
                        if(e.isCancel == 2){
                            _this.$message(e.code+this.msg('已取消，不能进行操作'));
                            return;
                        }
                    }

                    this.cancelOrderVisible = false;
                    _this.$axios.post(_this.$kit.api.updateColumn.updateCancel+'?value=2',selectes.map(e => e.id).join(","))
                        .then((res1) => {
                            if(res1.status){
                                _this.$message(res1.msg || _this.msg('更新成功'));
                                _this.list(false);
                                if(this.cancelOrderSyncShopee){
                                    //执行取消订单
                                    _this.$axios.get(_this.$kit.api.stock.cancelShopeeOrder+'?id='+selectes[0].id+'&type='+this.cancelOrderShopeeReason)
                                        .then((res2) => {
                                            _this.$message(res2.msg);
                                        });
                                }
                            }else{
                                _this.$message(res1.msg || _this.msg('更新失败'));
                            }
                        });
                });
        },
        submitHandleCancel(){
            if(this.handelCancelDecision === null || this.handelCancelDecision === undefined){
                this.$message(this.msg('请选择处理结果'));
                return;
            }
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.handelCancelVisible = false;
            this.$axios.get(this.$kit.api.stock.handelCancel+'?type='+this.handelCancelDecision+'&id='+selectes[0].id)
                .then((result) => {
                    if(result.status){
                        this.$message(result.msg || this.msg('更新成功'));
                        this.list(false);
                    }else{
                        this.$message(result.msg || this.msg('更新失败'));
                    }
                });
        },
        kuaidi(){//快递货物
            this.$refs.kuaidiRef.showDialog();
        },
        updateWeightTime(){//出货时间
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            let ids = selectes.map(e => e.id);
            this.weightTimeIds = ids;
            this.weightTimeVisible = true;
        },
        handleAdd(command){
            if(command == 'a'){
                this.doAdd(4);
            }else if(command == 'b'){
                this.doAdd(1);
            }else if(command == 'c'){
                this.doAdd(2);
            }else if(command == 'd'){
                // this.doAdd(3);
                this.$router.push({ name: 'stock-add-store'});
            }
        },
        handleGoodType(command){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length > 500){
                this.$message(this.msg('不能大于五百条'));
                return;
            }
            markOrderGoodType(command, selectes.map(s => s.id));
            
        },
        handlePkgType(command){
            if(command == 'a'){
                let selectes = this.$refs.dataTable.getCheckboxRecords();
                let stockIds = selectes.map(o => o.id);
                doUpdatePkgType(1, stockIds, ()=> {
                    this.$refs.pkgTypeDg.showDialog(stockIds.join(","), ()=>{
                        this.list(false)
                    });
                });
            }else if(command == 'b'){
                this.packVisible = true;
            }else if(command == 'c'){
                this.updatePkgTypeNew();
            }else if(command == 'd'){
                //跨仓合并包
                let selectes = this.$refs.dataTable.getCheckboxRecords();
                let stockIds = selectes.map(o => o.id);
                doUpdatePkgType(2, stockIds, ()=> {
                    // this.list(false);
                    this.$refs.startPkgTypeDg.showDialog(stockIds.join(","), ()=>{
                        this.list(false)
                    });
                });
            }
        },
        zhuanyunCommon(command){
            if(command == 'a'){
                this.zhuanyunPkg(0);
            }else if(command == 'b'){
                this.zhuanyunPkg(1);
            }else if(command == 'c'){
                this.qijianHandle();
            }else if(command == 'd'){
                this.updateRemark1();
            }else if(command == 'e'){
                var selectes = this.$refs.dataTable.getCheckboxRecords();
                if(selectes.length==0){
                    this.$message(this.msg('请选中一条数据进行操作'));
                    return;
                }
                this.$axios.post(this.$kit.api.stock.getStockByIds,selectes.map(e => e.id).join(","))
                    .then((result) => {
                        let data = result.data;
                        for(let i=0;i<data.length;i++){
                            let e = data[i];
                            if(e.status != 30){
                                this.$message(e.code+this.msg('非待出仓订单，不能通知出货'));
                                return;
                            }
                        }
                        this.$axios.post(this.$kit.api.stock.noticeSend,selectes.map(e => e.id).join(","))
                        .then((res) => {
                            if(res.data){
                                this.$message(res.msg || this.msg('更新成功'));
                            }else{
                                this.$message(res.msg || this.msg('更新失败'));
                            }
                        })
                    })
            }
        },
        updateRemark1(){//集运收费
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>1){
                this.$message(this.msg('只能选择一条数据'));
                return;
            }
            this.chargeId = selectes[0].id;
            this.zhuanyunChargeVisible = true;
        },
        handleOfflineCreate(command){//建单操作
            this.shipDate = null;
            if(command == 'a'){
                this.doOfflineCreate();//快速建单
            }else if(command == 'b'){
                this.finishOfflineCreate();//完成建单
            }else if(command == 'c'){
                // this.$message("正在开发，敬请期待")//重新建单
                this.getOfflineExpCode();
            }else if(command == 'd'){
                this.getOfflinePage();//同步线下面单
            }else if(command == 'e'){
                this.expCodeVisible = true;//录查询码
            }else if(command == 'f'){
               this.syncXzAddressCode();//同步新竹区码
            }else if(command == 'g'){
                var selectes = this.$refs.dataTable.getCheckboxRecords();
                if(selectes.length==0){
                    this.$message(this.msg('请选中一条数据进行操作'));
                    return;
                }
                if(selectes.length>1){
                    this.$message(this.msg('只能选择一条数据'));
                    return;
                }
               this.returnCodeVisible = true;//录退件码
            }
        },
        //同步订单
        doSyncOrder(){
            this.$refs.SyncOrderRef.showDialog();
        },
        doTrace(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>1){
                this.$message(this.msg('只能查询一条数据'));
                return;
            }
            let row = selectes[0];
            this.$refs.traceRef.showTracks(row.id, row.queryHistory);
        },
        doTrack(){//货态同步
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>5000){
                this.$message(this.msg('快递同步每次只能同步5000条数据'));
                return;
            }
            this.$confirm(this.msg('货态同步耗时较长，请勿短时间多次重复操作，是否进行同步操作?'), this.msg('提示'), {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.$kit.api.stock.doTrack, selectes.map(e => e.id).join(","))
                    .then((result) => {
                        if(result.data){
                            this.$message(result.msg || this.msg('正在同步'));
                        }else{
                            this.$message(this.msg('同步失败'));
                        }
                    })
            }).catch((err) => {
                // console.log(err);
            })
        },
        getReveicerTel(){//同步收件人电话
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>100){
                this.$message(this.msg('每次只能同步100条数据'));
                return;
            }
            this.$confirm(this.msg('同步耗时较长，请勿短时间多次重复操作，是否进行同步操作?'), this.msg('提示'), {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.$kit.api.stockDetail.getReceiverTel, selectes.map(e => e.id).join(","))
                    .then((result) => {
                        if(result.status){
                            this.$message(result.msg || this.msg('正在同步'));
                        }else{
                            this.$message(this.msg('同步失败'));
                        }
                    })
            }).catch((err) => {
                // console.log(err);
            })
        },
        doTrackExpress(){//快递同步
            this.$refs.SyncExpressDialogRef.showDialog();
        },
        doSyncExpress(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            trackExpress(selectes.map(e => e.id));
        },
        doOfflineCreate(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>100){
                this.$message(this.msg('单次最多选择100条数据'));
                return;
            }

            this.$confirm(this.msg('确定要执行建单操作?'), this.msg('提示'), {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let hasHM = false;
                selectes.forEach(e => {
                    if(e.expCompany && e.expCompany == '黑貓'){
                        hasHM = true;
                    }
                })
                if(hasHM){
                    this.shipDateVisiable = true;
                    this.shipDate = new Date();
                    this.pickerOptions = {
                        disabledDate(time) {
                            return time.getTime() < Date.now(); // 禁用小于当前日期的时间
                        }
                    }
                }else{
                    this.doOfflineCreateSubmit(selectes,null);
                }
            }).catch((err) => {
                // console.log(err);
            })

        },
        shipDateVisiableSubmit(){
            if(!this.shipDate){
                this.$message(this.msg('请选择出货日期'));
                return;
            }
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.doOfflineCreateSubmit(selectes,this.shipDate);
            this.shipDateVisiable = false;
        },
        doOfflineCreateSubmit(selectes,date){
            this.$axios.post(this.$kit.api.stock.offlineCreate+"?date="+date, selectes.map(e => e.id).join(","))
                .then((result) => {
                    if(result.status){
                        
                        let html = "<div style='max-height:500px; overflow:auto;'>";

                        result.data.forEach(e => {
                            html += "<p>单号："+e.code+" ("+e.id+"): "+e.errMsg+"</p>";
                        })

                        html+="</div>";

                        this.$message({
                            dangerouslyUseHTMLString: true,
                            message: html
                        });

                        // this.$message(result.msg || this.msg('执行成功'));
                        this.list();

                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        getOfflineExpCode(){//重新建单，把已建单但是未同步到查询码的订单重新同步建单信息
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>100){
                this.$message(this.msg('每次最多选择100条数据'));
                return;
            }
            this.$axios.post(this.$kit.api.stock.getOfflineExpCode, selectes.map(e => e.id).join(","))
                .then((result) => {
                    if(result.status){
                        this.$message(result.msg);
                    }else{
                        this.$message(result.msg || this.msg('单号不存在'));
                }
            });
        },
        getOfflinePage(){//同步线下面单
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>100){
                this.$message(this.msg('每次最多选择100条数据'));
                return;
            }
            this.$axios.post(this.$kit.api.stock.getOfflinePage, selectes.map(e => e.id).join(","))
                .then((result) => {
                    if(result.status){
                        this.$message(result.msg);
                    }else{
                        this.$message(result.msg || this.msg('单号不存在'));
                }
            });
        },
        syncXzAddressCode(){//同步新竹区码
          var selectes = this.$refs.dataTable.getCheckboxRecords();
          if(selectes.length==0){
            this.$message(this.msg('请选中一条数据进行操作'));
            return;
          }
          if(selectes.length>100){
            this.$message(this.msg('每次最多选择100条数据'));
            return;
          }
          this.$axios.post(this.$kit.api.stock.syncXzAddressCode, selectes.map(e => e.id).join(","))
              .then((result) => {
                if(result.status){
                  this.$message(result.msg);
                }else{
                  this.$message(result.msg || this.msg('单号不存在'));
                }
              });
        },
        openPkgCode(){//包号录入
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            var _this = this;
            this.$axios.post(_this.$kit.api.stock.getStockByIds,selectes.map(e => e.id).join(","))
                .then((result) => {
                    for(let i=0;i<result.data.length;i++){
                        let select = result.data[i];
                        if(select.isCancel == 1){
                            _this.$message(select.code + this.msg('已取消订单不能打包，请移除！'));
                            return;
                        }
                    }
                    this.pkgCodeVisible = true;
                })
        },
        autoPkgCode(){//扫码打包
            this.packageVisible = true;
        },
        finishOfflineCreate(){//完成建单
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            var _this = this;
            this.$confirm(this.msg("确定要将选中的数据改为线下已建单吗？"), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                _this.$axios.post(_this.$kit.api.updateColumn.updateOutTypeFinish+'?ids='+selectes.map(e => e.id).join(","))
                .then((result) => {
                    if(result.status){
                        _this.$message(result.msg || _this.msg('更新成功'));
                        _this.list(false);
                    }else{
                        _this.$message(result.msg || _this.msg('更新失败'));
                    }
                });
            }).catch((err) => {
                // console.log(err);
            });
        },
        showAdvSearch(){
            this.showQuery = !this.showQuery;
        },
        callMethod(name, param){
            if(param){
                this[name](param)
            }else{
                this[name]();
            }
        },
        //预览详情
        stockDetail(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            // if(selectes.length > 10){
            //     this.$message({
            //         message:this.msg('抱歉，请控制选择10个以内的订单打开详情！打开订单详情，需要自身电脑有足够的内存支持，如果你电脑内存不支持打开过多订单详情时会导致你的网页崩溃；我们在持续优化中，给你带来的不便深感抱歉！大批量打开订单详情你还可使用货物采购功能打开！'),
            //         type:'error'
            //     })
            //     return;
            // }

            let ids = selectes.map(e => e.id).join(",");
            window.localStorage.setItem("viewDetailIds", ids);
            window.localStorage.setItem("detailHistory", this.query.history);
            this.$tabs.open("/admin/stock/stock-detail");
        },
        openDetail(id, history){
            console.log("aa",history)
            window.localStorage.setItem("viewDetailIds", id);
            window.localStorage.setItem("detailHistory", history);
            this.$tabs.open("/admin/stock/stock-detail");
        },
        // stockSplit(){//详情分拆
        //     var selectes = this.$refs.dataTable.getCheckboxRecords();
        //     if(selectes.length == 0){
        //         this.$message(this.msg('请选中一条数据进行操作'));
        //         return;
        //     }

        //     let ids = selectes.map(e => e.id).join(",");
        //     window.localStorage.setItem("splitStockIds", ids);
        //     this.$tabs.open("/admin/stock/stock-split");
        // },
        stockDetailEdit(){//详情修改
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            let ids = selectes.map(e => e.id).join(",");
            window.localStorage.setItem("detailEditIds", ids);
            this.$tabs.open("/admin/stock/detail-edit");
            // this.$router.push("/admin/stock/detail-edit?ids="+ids);
        },
        stockDetailBuy(){//货物采购
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            axios.request({
                url: this.$kit.api.history.create+'?t=货物采购',
                method: 'get',
                headers: {"Content-Type":"application/json; charset=utf-8",
                    "X-Requested-With":"XMLHttpRequest",
                },
                withCredentials: true,
            }).then((result) => {
            });

            let ids = selectes.map(e => e.id).join(",");
            window.localStorage.setItem("viewDetailIdsNew", ids);
            this.$tabs.open("/admin/stock/stock-buy");
        },
        // stockQtyEdit(){//入库出库
        //     var selectes = this.$refs.dataTable.getCheckboxRecords();
        //     if(selectes.length == 0){
        //         this.$message(this.msg('请选中一条数据进行操作'));
        //         return;
        //     }

        //     let ids = selectes.map(e => e.id).join(",");
        //     window.localStorage.setItem("qtyEditIds", ids);
        //     this.$tabs.open("/admin/stock/qty-edit");
        // },
        // finance(command){
        //     var selectes = this.$refs.dataTable.getCheckboxRecords();
        //     if(selectes.length == 0){
        //         this.$message(this.msg('请选中一条数据进行操作'));
        //         return;
        //     }
        //     if(command == 'a'){//更新收费方式
        //         this.transitIds = selectes.map(e => e.id).join(",");
        //         this.transitTypeVisible = true;
        //     }else if(command == 'b'){//运费核算
        //         let ids = selectes.map(e => e.id).join(",");
        //         window.localStorage.setItem("stockIds1", ids);
        //         // this.$tabs.open("/admin/freight");
        //         this.$router.push("/admin/freight?len="+selectes.length);
        //     }else if(command == 'c'){//回款核算
        //         let ids = selectes.map(e => e.id).join(",");
        //         window.localStorage.setItem("proxyStockIds", ids);
        //         this.$router.push("/admin/proxy?len="+selectes.length);
        //     }else if(command == 'd'){//理赔核算
        //         let ids = selectes.map(e => e.id).join(",");
        //         window.localStorage.setItem("lipeiStockIds", ids);
        //         this.$router.push("/admin/lipei?len="+selectes.length);
        //     }else if(command == 'e'){//客诉件结算
        //         let ids = selectes.map(e => e.id).join(",");
        //         window.localStorage.setItem("kesuStockIds", ids);
        //         this.$router.push("/admin/kesu?len="+selectes.length);
        //     }
        // },
        doBatchSendOrderNew(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            batchSendOrderNew(selectes.map(e => e.id));
        },
        doBatchSendOrder(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length > 500){
                this.$message(this.msg('单次一键发货的数量不能超过五百'));
                return;
            }

            this.$confirm(this.msg('确定要将选中的订单全部发货吗'), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                // this.$axios.post(this.$kit.api.stock.batchSendOrder, selectes.map(e => e.id).join(","))
                //     .then((result) => {
                //         if(result.status){
                //             this.$message(result.msg || this.msg('更新成功'));
                //         }else{
                //             this.$message(result.msg || this.msg('更新失败'));
                //         }
                //     });
                axios.request({
                    url: this.$kit.api.stock.batchSendOrder, 
                    method: 'post',
                    data: selectes.map(e => e.id).join(","),
                    headers: {"Content-Type":"application/json; charset=utf-8",
                        "X-Requested-With":"XMLHttpRequest",
                    },
                    withCredentials: true,
                }).then((result) => {
                    if(result.status){
                        this.$message(result.msg || this.msg('更新成功'));
                    }else{
                        this.$message(result.msg || this.msg('更新失败'));
                    }
                });
            }).catch((err) => {
                // console.log(err);
            });
        },
        doBatchSendOrder1(){//空白面单
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$confirm(this.msg('本操作将无条件删除面单，是否确认删除？'), this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                axios.request({
                    url: this.$kit.api.stock.batchSendOrder1,
                    method: 'post',
                    data: selectes.map(e => e.id).join(","),
                    headers: {"Content-Type":"application/json; charset=utf-8",
                        "X-Requested-With":"XMLHttpRequest",
                    },
                    withCredentials: true,
                }).then((result) => {
                    if(result.status){
                        this.$message(result.msg || this.msg('更新成功'));
                    }else{
                        this.$message(result.msg || this.msg('更新失败'));
                    }
                });
            }).catch((err) => {
                // console.log(err);
            });
        },
        zhineng(command){//智能理货
            if(command == 'a'){
                this.$refs.expressSortingRef.showDialog();
            }else if(command == 'b'){
                this.$refs.expStockRef.showDialog();
            }
        },
        stockCodeCheck(){//条码校对
            this.$tabs.open("/admin/code-check");
        },
        openedExpCode(){
            this.$nextTick(() => {
                this.$refs.expCodeRef.init();
            });
        },
        openedReturnCode(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            let code = selectes[0].code;
            let id = selectes[0].id;
            this.$nextTick(() => {
                this.$refs.returnCodeRef.init(id,code);
            });
        },
        openedActualCode(){ 
            this.$nextTick(() => {
                this.$refs.actualCodeRef.init();
            });
        },
        openedJiaojie(){
            this.$nextTick(() => {
                this.$refs.jiaojieRef.init();
            });
        },
        openedPack(){
            this.$nextTick(() => {
                this.$refs.packRef.init();
            });
        },
        openedCharge(){
            this.$nextTick(() => {
                this.$refs.chargeRef.init();
            });
        },
        expCodeDg(){
            this.expCodeVisible = false;
        },
        returnCodeDg(){
            this.returnCodeVisible = false;
        },
        actualCodeDg(){
            this.actualCodeVisible = false;
        },
        jiaojieDg(){
            this.jiaojieVisible = false;
        },
        packDg(){
            this.packVisible = false;
        },
        chargeDg(){
            this.zhuanyunChargeVisible = false;
        },
        openedExpTjSort(){
            this.$nextTick(() => {
                this.$refs.exportTjRef.init();
            });
        },
        openedWeightTime(){
            this.$nextTick(() => {
                this.$refs.weightTimeRef.init();
            });
        },
        openPrintPkgDg(){
            this.$nextTick(() => {
                this.$refs.printPkgDg.init();
            });
        },
        openPrintPkgDgAuto(){
            this.$nextTick(() => {
                this.$refs.printPkgDgAuto.init();
            });
        },
        openPrintPkgDgAutoP(){
            this.$nextTick(() => {
                this.$refs.printPkgDgAutoP.init();
            });
        },
        openPrintRealDg(){
            this.$nextTick(() => {
                this.$refs.printRealDg.init(this.printRealType);
            });
        },
        openPrintKuTagDg(){
            this.$nextTick(() => {
                this.$refs.printKuTagDg.init();
            });
        },
        openedTransitType(){
            this.$nextTick(() => {
                this.$refs.transitTypeRef.init();
            });
        },
        exportTjDg(){
            this.exportTjVisible = false;
        },
        weightTimeDg(){
            this.weightTimeIds = null;
            this.weightTimeVisible = false;
        },
        refreshCols(visible, col){
            this.$refs.dataTable.refreshColumn()
            // console.log(visible, col);
        },
        ctrlBoxHeightChanged(height){
            this.emptyFixedBoxHeight = height;
        },
        closeWorkOrderAddDialog(type){  //添加弹窗关闭后的回调事件
          this.createWorkOrderVisible = false;
          // if (type) { //提交成功后清除选中行
          //   var table = this.$refs.dataTable;
          //   table.clearCheckboxRow();
          // }
        },
        openedDeclareCheck(){
            this.$nextTick(() => {
                this.$refs.declareCheck.init(this.declareCheckIds);
            });
        },
        closeStockDeclareCheckDialog(result) {  //添加弹窗关闭后的回调事件
          this.declareCheckVisible = false;
          if (result) {
            this.list();
          }
        },
        syncAllShoplineOrders() {
          var _this = this;
          _this.$axios.get(_this.$kit.api.shopline.syncAllOrders + "?password=009mgipgant")
              .then((result) => {
                if (result.status) {
                  _this.$message.success(_this.msg(result.msg));
                  _this.list();
                } else {
                  _this.$message.error(result.msg);
                }
              });
        },
        doOrderDetailSplit(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$refs.orderSplitDialogRef.showDialog(selectes.map(e => e.id).join(","));
        }
    }
    
}
</script>

<style scoped lang="scss">
.view-group h5{margin-top:8px; margin-bottom:8px; border-bottom: 1px solid #dcdfe6;}
.view-group >>> .el-link{display:inline-block; padding: 5px 15px;}
.view-cell{cursor:pointer; display:inline-block; margin-right:5px;}
.detail-cell{cursor:pointer; display:inline-block; margin-right:5px;}
.status-cell{cursor:pointer; display:inline-block; margin-right:5px;}
.remove-cell{cursor:pointer; display:inline-block; color:red;}
.page-box{overflow-y:auto;}
.ctrl-box{position: absolute;z-index:99;width:100%;}
.empty-fixed-box{height:57.5px;}
</style>
